export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  Int64: { input: number; output: number };
  Int64ID: { input: any; output: any };
  Map: { input: any; output: any };
  StringArray: { input: string[]; output: string[] };
  StringID: { input: any; output: any };
  StringMap: { input: Record<string, string>; output: Record<string, string> };
  Timestamp: { input: string; output: string };
  UInt64: { input: any; output: any };
  Upload: { input: any; output: any };
};

export type AiChatLimitStatus = {
  __typename?: 'AIChatLimitStatus';
  current_count: Scalars['Int64']['output'];
  limit: Scalars['Int64']['output'];
  workspace_id: Scalars['ID']['output'];
};

export type AiConversationHistoryResults = {
  __typename?: 'AIConversationHistoryResults';
  conversations: Array<AiConversationSummary>;
  totalCount: Scalars['Int64']['output'];
};

export type AiConversationSummary = {
  __typename?: 'AIConversationSummary';
  /**
   * Agent kind recorded on the conversation row (e.g. factory-analyze).
   * Null for conversations that never set agent_kind.
   */
  agent_kind?: Maybe<Scalars['String']['output']>;
  agent_message_count: Scalars['Int']['output'];
  conversation_id: Scalars['StringID']['output'];
  initiated_at: Scalars['Timestamp']['output'];
  is_shared: Scalars['Boolean']['output'];
  /**
   * Timestamp of the most recent user-sent prompt in the conversation.
   * The "Most recent chats" sidebar sorts by this so the chat the user
   * most recently prompted appears first. Falls back to initiated_at for
   * conversations that have no user messages yet.
   */
  last_user_message_at: Scalars['Timestamp']['output'];
  message_preview: Scalars['String']['output'];
  /**
   * CHAT for interactive Vega conversations; RUN for agent workflows
   * (factory-analyze, flag cleanup, auto-investigation). Stored at insert.
   */
  origin: AgentConversationOrigin;
  /** Workflow type when origin is RUN. Null for chats. */
  run_kind?: Maybe<AgentConversationRunKind>;
  /**
   * Lifecycle status of the conversation as tracked on the
   * `agent_conversations.status` column. Mirrors the field exposed by
   * `ConversationHistoryResponse.status` so list and detail views agree.
   * Known values: "active" (in-progress), "completed", "stopped" (user
   * cancelled), "failed". Non-null because every row has a default of
   * "active" at insert time.
   */
  status: Scalars['String']['output'];
  tags?: Maybe<Array<ConversationTag>>;
  /**
   * Haiku-generated 4–8 word chat title written by the background
   * goroutine inside agent.Client.SendPromptWithMessages — the single
   * choke point every conversation entry flow funnels through. Null
   * for historical conversations created before titling shipped (no
   * backfill) and for in-flight conversations whose title goroutine
   * hasn't finished yet — clients should fall back to a placeholder
   * in either case.
   */
  title?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
  user_message_count: Scalars['Int']['output'];
};

export type AwsMarketplaceSubscription = {
  __typename?: 'AWSMarketplaceSubscription';
  customer_aws_account_id: Scalars['String']['output'];
  customer_identifier: Scalars['String']['output'];
  product_code: Scalars['String']['output'];
};

export type AccessibleJiraResources = {
  __typename?: 'AccessibleJiraResources';
  avatarUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  url: Scalars['String']['output'];
};

export type Account = {
  __typename?: 'Account';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  member_count: Scalars['Int']['output'];
  member_limit?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  paid_prev: Scalars['Int']['output'];
  paid_prev_prev: Scalars['Int']['output'];
  plan_tier: Scalars['String']['output'];
  session_count_cur: Scalars['Int']['output'];
  session_count_prev: Scalars['Int']['output'];
  session_count_prev_prev: Scalars['Int']['output'];
  session_limit: Scalars['Int']['output'];
  stripe_customer_id: Scalars['String']['output'];
  subscription_start?: Maybe<Scalars['Timestamp']['output']>;
  unlimited_members: Scalars['Boolean']['output'];
  view_count_cur: Scalars['Int']['output'];
  view_count_prev: Scalars['Int']['output'];
};

export type AccountDetails = {
  __typename?: 'AccountDetails';
  id: Scalars['ID']['output'];
  members: Array<AccountDetailsMember>;
  name: Scalars['String']['output'];
  session_count_per_day?: Maybe<Array<Maybe<NamedCount>>>;
  session_count_per_month?: Maybe<Array<Maybe<NamedCount>>>;
  stripe_customer_id: Scalars['String']['output'];
};

export type AccountDetailsMember = {
  __typename?: 'AccountDetailsMember';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_active?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  about_you_details_filled?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  heard_about?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<Scalars['String']['output']>;
  slack_im_channel_id?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  user_defined_persona?: Maybe<Scalars['String']['output']>;
  user_defined_role?: Maybe<Scalars['String']['output']>;
  user_defined_team_size?: Maybe<Scalars['String']['output']>;
};

export type AdminAboutYouDetails = {
  first_name: Scalars['String']['input'];
  heard_about: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_home_contact_allowed: Scalars['Boolean']['input'];
  referral: Scalars['String']['input'];
  user_defined_persona: Scalars['String']['input'];
  user_defined_role: Scalars['String']['input'];
  user_defined_team_size: Scalars['String']['input'];
};

export type AdminAndWorkspaceDetails = {
  allowed_auto_join_email_origins?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  heard_about: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone_home_contact_allowed: Scalars['Boolean']['input'];
  promo_code?: InputMaybe<Scalars['String']['input']>;
  referral: Scalars['String']['input'];
  user_defined_role: Scalars['String']['input'];
  user_defined_team_size: Scalars['String']['input'];
  workspace_name: Scalars['String']['input'];
};

export enum AdminRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
}

export type AdvancedSearchParamsInput = {
  bucket_by_key?: InputMaybe<Scalars['String']['input']>;
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_interval?: InputMaybe<Scalars['Int']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  graph_type?: InputMaybe<Scalars['String']['input']>;
  group_by_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_function_type?: InputMaybe<MetricAggregator>;
  limit_metric?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Primary list-axis for conversation history: interactive Vega chats vs
 * agent workflow runs (factory-analyze, flag cleanup, auto-investigation).
 * Stored on the conversation row at insert (default CHAT).
 */
export enum AgentConversationOrigin {
  Chat = 'CHAT',
  Run = 'RUN',
}

/** Workflow type of a RUN conversation. Null on CHAT rows. */
export enum AgentConversationRunKind {
  AutoInvestigation = 'AUTO_INVESTIGATION',
  FactoryAnalyze = 'FACTORY_ANALYZE',
  FlagCleanup = 'FLAG_CLEANUP',
}

export type AgentDispatchInput = {
  ai_config_key: Scalars['String']['input'];
  max_turns?: InputMaybe<Scalars['Int']['input']>;
  project_slug: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  repositories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AgentDispatchPayload = {
  __typename?: 'AgentDispatchPayload';
  conversation_id: Scalars['StringID']['output'];
  success: Scalars['Boolean']['output'];
};

export type AgentDispatchStatusPayload = {
  __typename?: 'AgentDispatchStatusPayload';
  conversation_id: Scalars['StringID']['output'];
  messages: Array<ConversationMessage>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<ConversationTag>>;
};

export type AgentFollowupPromptInput = {
  correlationId: Scalars['String']['input'];
  messageText: Scalars['String']['input'];
  slackChannelId: Scalars['String']['input'];
  slackTeamId: Scalars['String']['input'];
};

export type AgentFollowupPromptPayload = {
  __typename?: 'AgentFollowupPromptPayload';
  success: Scalars['Boolean']['output'];
};

export type AgentMessage = {
  __typename?: 'AgentMessage';
  conversation_id: Scalars['StringID']['output'];
  is_final: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  turn: Scalars['Int']['output'];
};

export type AgentPromptInput = {
  conversation_id?: InputMaybe<Scalars['StringID']['input']>;
  environments?: InputMaybe<Array<AgentRolloutEnvironmentInput>>;
  max_turns?: InputMaybe<Scalars['Int']['input']>;
  permission_mode?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['StringID']['input'];
  prompt: Scalars['String']['input'];
  repositories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AgentRolloutEnvironmentInput = {
  environment_key: Scalars['String']['input'];
  override?: InputMaybe<AgentRolloutOverrideInput>;
  release_type?: InputMaybe<Scalars['String']['input']>;
};

export type AgentRolloutOverrideInput = {
  metric_group_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  metric_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  release_method: Scalars['String']['input'];
  rollback_on_regression?: InputMaybe<Scalars['Boolean']['input']>;
  rollout_context_kind_key?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Array<AgentRolloutStageInput>>;
};

export type AgentRolloutStageInput = {
  allocation: Scalars['Int']['input'];
  duration_millis: Scalars['Int64']['input'];
};

export type Alert = {
  __typename?: 'Alert';
  auto_investigation_enabled: Scalars['Boolean']['output'];
  destinations: Array<Maybe<AlertDestination>>;
  disabled: Scalars['Boolean']['output'];
  evaluation_delay_seconds?: Maybe<Scalars['Int']['output']>;
  function_column?: Maybe<Scalars['String']['output']>;
  function_type: MetricAggregator;
  group_by_key?: Maybe<Scalars['String']['output']>;
  group_by_keys?: Maybe<Array<Scalars['String']['output']>>;
  hide_graph: Scalars['Boolean']['output'];
  high_cardinality: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  investigation_conversation_id?: Maybe<Scalars['String']['output']>;
  investigation_cooldown?: Maybe<Scalars['Int']['output']>;
  investigation_prompt?: Maybe<Scalars['String']['output']>;
  investigation_repositories?: Maybe<Scalars['StringArray']['output']>;
  investigation_started_at?: Maybe<Scalars['Timestamp']['output']>;
  last_admin_to_edit_id?: Maybe<Scalars['ID']['output']>;
  last_admin_to_edit_uid?: Maybe<Scalars['String']['output']>;
  message_content?: Maybe<Scalars['String']['output']>;
  metric_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  no_data_behavior: NoDataBehavior;
  permission_mode?: Maybe<Scalars['String']['output']>;
  /**
   * Optional population-level (second-pass) aggregator enabling two-level
   * aggregation. When set, values are first aggregated per unit — identified by
   * `group_by_keys` (e.g. a context/user key) — using `function_type`, then
   * aggregated across those units using `population_function_type`, e.g.
   * `P99( Sum(value) per user )`. The alert evaluates its threshold against the
   * resulting single collapsed series (one value per bucket). `group_by_keys`
   * must be set. Null (the default) means ordinary single-pass aggregation.
   * Set to `PercentUnits` to alert on the share of population units that sent a
   * `query`-matching event (requires `population_query` or `population_window`).
   */
  population_function_type?: Maybe<MetricAggregator>;
  /**
   * Optional filter selecting the events whose senders form the unit population
   * (the denominator) for two-level aggregation, e.g.
   * `key=(page_view OR session_start)`. Same filter language as `query`.
   *
   * Empty (the default): the population is implicit — only units observed via
   * `query`-matching events participate in the population aggregation; units
   * are never zero-filled.
   *
   * Present: the population is every unit that sent a matching event within
   * `population_window`. Population units with no `query`-matching events in
   * the evaluation window contribute 0 (for per-unit Sum/Count) or count as
   * non-matching units (for PercentUnits). Units that match `query` but are
   * not in the population are excluded — the population defines the universe.
   *
   * Requires `population_function_type`. Population alerts support constant
   * thresholds only.
   */
  population_query?: Maybe<Scalars['String']['output']>;
  /**
   * Rolling lookback in seconds for the population, ending at each evaluation.
   * Defaults to `threshold_window`; must be >= `threshold_window`. May be set
   * without `population_query`, making the population "units that sent
   * `query`-matching events over this longer window" (e.g. of the units that
   * purchased in the last 24h, what share purchased in the last 10 minutes).
   *
   * Requires `population_function_type`.
   */
  population_window?: Maybe<Scalars['Int']['output']>;
  product_type: ProductType;
  project_id: Scalars['ID']['output'];
  query?: Maybe<Scalars['String']['output']>;
  send_resolved_alert: Scalars['Boolean']['output'];
  sql?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['StringMap']['output']>;
  threshold_condition?: Maybe<ThresholdCondition>;
  threshold_cooldown?: Maybe<Scalars['Int']['output']>;
  threshold_type?: Maybe<ThresholdType>;
  threshold_value?: Maybe<Scalars['Float']['output']>;
  threshold_window?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  warn_threshold_value?: Maybe<Scalars['Float']['output']>;
};

export type AlertConfigurationInput = {
  alert_id?: InputMaybe<Scalars['ID']['input']>;
  destinations: Array<AlertDestinationInput>;
  evaluation_delay_seconds?: InputMaybe<Scalars['Int']['input']>;
  function_column?: InputMaybe<Scalars['String']['input']>;
  function_type: MetricAggregator;
  group_by_key?: InputMaybe<Scalars['String']['input']>;
  group_by_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  hide_graph?: InputMaybe<Scalars['Boolean']['input']>;
  message_content?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  no_data_behavior?: InputMaybe<NoDataBehavior>;
  /**
   * Optional population-level (second-pass) aggregator enabling two-level
   * aggregation: values are first aggregated per unit (`group_by_keys`) using
   * `function_type`, then aggregated across units using
   * `population_function_type`, e.g. `P99( Sum(value) per user )`. Requires
   * `group_by_keys`. Null means ordinary single-pass aggregation.
   */
  population_function_type?: InputMaybe<MetricAggregator>;
  /**
   * Optional filter selecting the events whose senders form the unit population
   * (the denominator) for two-level aggregation, e.g.
   * `key=(page_view OR session_start)`. Same filter language as `query`.
   *
   * Empty (the default): the population is implicit — only units observed via
   * `query`-matching events participate in the population aggregation; units
   * are never zero-filled.
   *
   * Present: the population is every unit that sent a matching event within
   * `population_window`. Population units with no `query`-matching events in
   * the evaluation window contribute 0 (for per-unit Sum/Count) or count as
   * non-matching units (for PercentUnits). Units that match `query` but are
   * not in the population are excluded — the population defines the universe.
   *
   * Requires `population_function_type`. Population alerts support constant
   * thresholds only.
   */
  population_query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Rolling lookback in seconds for the population, ending at each evaluation.
   * Defaults to `threshold_window`; must be >= `threshold_window`. May be set
   * without `population_query`, making the population "units that sent
   * `query`-matching events over this longer window" (e.g. of the units that
   * purchased in the last 24h, what share purchased in the last 10 minutes).
   *
   * Requires `population_function_type`.
   */
  population_window?: InputMaybe<Scalars['Int']['input']>;
  product_type: ProductType;
  query?: InputMaybe<Scalars['String']['input']>;
  send_resolved_alert?: InputMaybe<Scalars['Boolean']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['StringMap']['input']>;
  threshold_condition?: InputMaybe<ThresholdCondition>;
  threshold_cooldown?: InputMaybe<Scalars['Int']['input']>;
  threshold_type?: InputMaybe<ThresholdType>;
  threshold_value?: InputMaybe<Scalars['Float']['input']>;
  threshold_window?: InputMaybe<Scalars['Int']['input']>;
  warn_threshold_value?: InputMaybe<Scalars['Float']['input']>;
};

export type AlertDestination = {
  __typename?: 'AlertDestination';
  alert_id: Scalars['ID']['output'];
  destination_type: AlertDestinationType;
  id: Scalars['ID']['output'];
  type_id: Scalars['String']['output'];
  type_name: Scalars['String']['output'];
};

export type AlertDestinationInput = {
  destination_type: AlertDestinationType;
  type_id: Scalars['String']['input'];
  type_name: Scalars['String']['input'];
};

export enum AlertDestinationType {
  Email = 'Email',
  Jira = 'Jira',
  Slack = 'Slack',
  Webhook = 'Webhook',
}

export type AlertGroupState = {
  __typename?: 'AlertGroupState';
  alert_id: Scalars['ID']['output'];
  alert_version: Scalars['Int']['output'];
  created_at: Scalars['Timestamp']['output'];
  current_state: AlertGroupStateValue;
  group_by_key: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  investigation_conversation_id?: Maybe<Scalars['String']['output']>;
  last_notified_at?: Maybe<Scalars['Timestamp']['output']>;
  last_state: AlertGroupStateValue;
};

export type AlertGroupStateResults = {
  __typename?: 'AlertGroupStateResults';
  states: Array<AlertGroupState>;
  total_count: Scalars['Int64']['output'];
};

export enum AlertGroupStateValue {
  Alert = 'Alert',
  Error = 'Error',
  NoData = 'NoData',
  Normal = 'Normal',
  Warn = 'Warn',
}

export enum AlertState {
  Alerting = 'Alerting',
  AlertingSilently = 'AlertingSilently',
  Error = 'Error',
  Normal = 'Normal',
  Warning = 'Warning',
}

export type AlertStateChange = {
  __typename?: 'AlertStateChange';
  alertID: Scalars['ID']['output'];
  groupByKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  investigationConversationId?: Maybe<Scalars['String']['output']>;
  projectID: Scalars['ID']['output'];
  state: AlertState;
  timestamp: Scalars['Timestamp']['output'];
};

export type AlertStateChangeResults = {
  __typename?: 'AlertStateChangeResults';
  alertStateChanges: Array<Maybe<AlertStateChange>>;
  totalCount: Scalars['Int64']['output'];
};

export type AllProjectSettings = {
  __typename?: 'AllProjectSettings';
  autoResolveStaleErrorsDayInterval: Scalars['Int']['output'];
  billing_email?: Maybe<Scalars['String']['output']>;
  error_filters?: Maybe<Scalars['StringArray']['output']>;
  error_json_paths?: Maybe<Scalars['StringArray']['output']>;
  excluded_users?: Maybe<Scalars['StringArray']['output']>;
  filterSessionsWithoutError: Scalars['Boolean']['output'];
  filter_chrome_extension?: Maybe<Scalars['Boolean']['output']>;
  filter_rules?: Maybe<ProjectFilterRules>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rage_click_count?: Maybe<Scalars['Int']['output']>;
  rage_click_radius_pixels?: Maybe<Scalars['Int']['output']>;
  rage_click_window_seconds?: Maybe<Scalars['Int']['output']>;
  sampling: Sampling;
  verbose_id: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  workspace_id: Scalars['ID']['output'];
};

export type AllWorkspaceSettings = {
  __typename?: 'AllWorkspaceSettings';
  ai_insights: Scalars['Boolean']['output'];
  enable_billing_limits: Scalars['Boolean']['output'];
  enable_business_dashboards: Scalars['Boolean']['output'];
  enable_business_projects: Scalars['Boolean']['output'];
  enable_business_retention: Scalars['Boolean']['output'];
  enable_business_seats: Scalars['Boolean']['output'];
  enable_data_deletion: Scalars['Boolean']['output'];
  enable_grafana_dashboard: Scalars['Boolean']['output'];
  enable_ingest_filtering: Scalars['Boolean']['output'];
  enable_ingest_sampling: Scalars['Boolean']['output'];
  enable_jira_integration: Scalars['Boolean']['output'];
  enable_network_traces: Scalars['Boolean']['output'];
  enable_project_level_access: Scalars['Boolean']['output'];
  enable_session_export: Scalars['Boolean']['output'];
  enable_sso: Scalars['Boolean']['output'];
  enable_teams_integration: Scalars['Boolean']['output'];
  enable_unlisted_sharing: Scalars['Boolean']['output'];
  workspace_id: Scalars['ID']['output'];
};

export type Artifact = {
  __typename?: 'Artifact';
  created_at: Scalars['Timestamp']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload?: Maybe<Scalars['Any']['output']>;
  project_id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ArtifactConversationLink = {
  __typename?: 'ArtifactConversationLink';
  artifacts: Array<ArtifactConversationLinkArtifact>;
  conversation_id: Scalars['StringID']['output'];
  is_shared: Scalars['Boolean']['output'];
  linked_at: Scalars['Timestamp']['output'];
  message_preview: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  /**
   * Haiku-generated chat title from `agent_conversations.title` — the same
   * string the Vega conversation breadcrumb shows. Null for conversations
   * created before titling shipped and for in-flight runs whose title
   * goroutine hasn't finished; clients fall back to message_preview.
   */
  title?: Maybe<Scalars['String']['output']>;
  user_email: Scalars['String']['output'];
};

export type ArtifactConversationLinkArtifact = {
  __typename?: 'ArtifactConversationLinkArtifact';
  artifact: Artifact;
  relationship: Scalars['String']['output'];
};

export enum ArtifactCreatorFilter {
  Any = 'ANY',
  Mine = 'MINE',
}

export type ArtifactDetail = {
  __typename?: 'ArtifactDetail';
  artifact: Artifact;
  conversation_links: Array<ArtifactConversationLink>;
  events: Array<ArtifactEvent>;
  github_pull_request?: Maybe<ArtifactPullRequest>;
};

export type ArtifactEvent = {
  __typename?: 'ArtifactEvent';
  conversation_id?: Maybe<Scalars['StringID']['output']>;
  created_at: Scalars['Timestamp']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload?: Maybe<Scalars['Any']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ArtifactPullRequest = {
  __typename?: 'ArtifactPullRequest';
  additions: Scalars['Int']['output'];
  body?: Maybe<Scalars['String']['output']>;
  changed_files: Scalars['Int']['output'];
  checks: ArtifactPullRequestChecks;
  created_at: Scalars['Timestamp']['output'];
  deletions: Scalars['Int']['output'];
  draft: Scalars['Boolean']['output'];
  html_url: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  owner: Scalars['String']['output'];
  repo: Scalars['String']['output'];
  reviews: Array<ArtifactPullRequestReview>;
  state: Scalars['String']['output'];
  timeline: Array<ArtifactPullRequestTimelineEvent>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ArtifactPullRequestChecks = {
  __typename?: 'ArtifactPullRequestChecks';
  failure: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  success: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ArtifactPullRequestReview = {
  __typename?: 'ArtifactPullRequestReview';
  state: Scalars['String']['output'];
  submitted_at?: Maybe<Scalars['Timestamp']['output']>;
  user: Scalars['String']['output'];
};

export type ArtifactPullRequestTimelineEvent = {
  __typename?: 'ArtifactPullRequestTimelineEvent';
  actor: Scalars['String']['output'];
  at: Scalars['Timestamp']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ArtifactResults = {
  __typename?: 'ArtifactResults';
  artifacts: Array<Artifact>;
  totalCount: Scalars['Int64']['output'];
};

export type AutomatedFlagCleanupInput = {
  flag_keys: Array<Scalars['String']['input']>;
  project_slug: Scalars['String']['input'];
  prompt_override?: InputMaybe<Scalars['String']['input']>;
  repositories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AutomatedFlagCleanupPayload = {
  __typename?: 'AutomatedFlagCleanupPayload';
  accepted: Scalars['Boolean']['output'];
};

export type AutomatedRolloutConfig = {
  __typename?: 'AutomatedRolloutConfig';
  completed_at?: Maybe<Scalars['Int64']['output']>;
  created_at?: Maybe<Scalars['Int64']['output']>;
  deployment_trigger?: Maybe<Scalars['String']['output']>;
  environments: Array<AutomatedRolloutEnvironment>;
  flag_key: Scalars['String']['output'];
  id: Scalars['String']['output'];
  merge_position?: Maybe<Scalars['Int64']['output']>;
  pr_number?: Maybe<Scalars['Int']['output']>;
  pr_state: Scalars['String']['output'];
  pr_url?: Maybe<Scalars['String']['output']>;
  project_key: Scalars['String']['output'];
  repo_full_name?: Maybe<Scalars['String']['output']>;
  required_application_keys?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['Int64']['output']>;
};

export type AutomatedRolloutEnvironment = {
  __typename?: 'AutomatedRolloutEnvironment';
  associated_release_id?: Maybe<Scalars['String']['output']>;
  desired_release_type: Scalars['String']['output'];
  environment_key: Scalars['String']['output'];
  override?: Maybe<AutomatedRolloutOverride>;
  released_at?: Maybe<Scalars['Int64']['output']>;
};

export type AutomatedRolloutOverride = {
  __typename?: 'AutomatedRolloutOverride';
  metric_group_keys?: Maybe<Array<Scalars['String']['output']>>;
  metric_keys?: Maybe<Array<Scalars['String']['output']>>;
  release_method: Scalars['String']['output'];
  rollback_on_regression?: Maybe<Scalars['Boolean']['output']>;
  rollout_context_kind_key?: Maybe<Scalars['String']['output']>;
  stages?: Maybe<Array<AutomatedRolloutStage>>;
};

export type AutomatedRolloutStage = {
  __typename?: 'AutomatedRolloutStage';
  allocation: Scalars['Int']['output'];
  duration_millis: Scalars['Int64']['output'];
};

export type AverageSessionLength = {
  __typename?: 'AverageSessionLength';
  length: Scalars['Float']['output'];
};

export type BatchedMetricsResult = {
  __typename?: 'BatchedMetricsResult';
  metrics: MetricsBuckets;
  query_id: Scalars['String']['output'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  errorsBillingLimit?: Maybe<Scalars['Int64']['output']>;
  errorsDailyAverage: Scalars['Float']['output'];
  errorsMeter: Scalars['Int64']['output'];
  logsBillingLimit?: Maybe<Scalars['Int64']['output']>;
  logsDailyAverage: Scalars['Float']['output'];
  logsMeter: Scalars['Int64']['output'];
  membersMeter: Scalars['Int64']['output'];
  meter: Scalars['Int64']['output'];
  metricsBillingLimit?: Maybe<Scalars['Int64']['output']>;
  metricsDailyAverage: Scalars['Float']['output'];
  metricsMeter: Scalars['Int64']['output'];
  plan: Plan;
  sessionsBillingLimit?: Maybe<Scalars['Int64']['output']>;
  sessionsDailyAverage: Scalars['Float']['output'];
  tracesBillingLimit?: Maybe<Scalars['Int64']['output']>;
  tracesDailyAverage: Scalars['Float']['output'];
  tracesMeter: Scalars['Int64']['output'];
};

export type CategoryHistogramBucket = {
  __typename?: 'CategoryHistogramBucket';
  category: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type CategoryHistogramPayload = {
  __typename?: 'CategoryHistogramPayload';
  buckets: Array<CategoryHistogramBucket>;
};

export type ChartPreviewBucket = {
  __typename?: 'ChartPreviewBucket';
  bucketEnd: Scalars['Timestamp']['output'];
  bucketStart: Scalars['Timestamp']['output'];
  count: Scalars['Int']['output'];
};

export type ChunkPreviewFrame = {
  __typename?: 'ChunkPreviewFrame';
  ts_ms: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type ClickInformation = {
  __typename?: 'ClickInformation';
  classname: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  elementId: Scalars['String']['output'];
  sessionCount: Scalars['Int']['output'];
  sessionInformation: Array<ClickSessionInformation>;
  tag: Scalars['String']['output'];
  text: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
  xpath: Scalars['String']['output'];
};

export type ClickSessionInformation = {
  __typename?: 'ClickSessionInformation';
  secureSessionID: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

/**
 * A session in the overlapping-tab group of the queried session: same browser
 * and same user, reachable by hops between sessions that overlap in time. The
 * queried session is included, and every member of a group returns the same
 * set, so Tab N labels stay stable as you move between concurrent tabs.
 */
export type ConcurrentBrowserTabSession = {
  __typename?: 'ConcurrentBrowserTabSession';
  active_length: Scalars['Float']['output'];
  client_id: Scalars['String']['output'];
  end_ts: Scalars['Timestamp']['output'];
  id: Scalars['Int64ID']['output'];
  identified: Scalars['Boolean']['output'];
  identifier: Scalars['String']['output'];
  length: Scalars['Float']['output'];
  secure_id: Scalars['String']['output'];
  start_ts: Scalars['Timestamp']['output'];
};

export type Connection = {
  pageInfo: PageInfo;
};

export type Conversation = {
  __typename?: 'Conversation';
  active_duration_ns: Scalars['Int64']['output'];
  conversationID: Scalars['String']['output'];
  error_count: Scalars['UInt64']['output'];
  first_timestamp: Scalars['Timestamp']['output'];
  input_tokens: Scalars['UInt64']['output'];
  last_timestamp: Scalars['Timestamp']['output'];
  models: Array<Scalars['String']['output']>;
  output_tokens: Scalars['UInt64']['output'];
  projectID: Scalars['Int']['output'];
  providers: Array<Scalars['String']['output']>;
  span_count: Scalars['UInt64']['output'];
  timestamp: Scalars['Timestamp']['output'];
  trace_count: Scalars['UInt64']['output'];
};

export type ConversationConnection = Connection & {
  __typename?: 'ConversationConnection';
  edges: Array<ConversationEdge>;
  pageInfo: PageInfo;
  sampled: Scalars['Boolean']['output'];
};

export type ConversationEdge = Edge & {
  __typename?: 'ConversationEdge';
  cursor: Scalars['String']['output'];
  node: Conversation;
};

export type ConversationHistoryResponse = {
  __typename?: 'ConversationHistoryResponse';
  /**
   * The failure reason recorded on the conversation when status is
   * "failed"; null otherwise. Truncated server-side — this is a summary
   * for the terminal error state in the UI, not a full stack trace.
   */
  error?: Maybe<Scalars['String']['output']>;
  messages: Array<ConversationMessage>;
  status: Scalars['String']['output'];
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  content: Scalars['Any']['output'];
  conversation_id: Scalars['StringID']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_final: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  tokens_used?: Maybe<Scalars['Int']['output']>;
  turn: Scalars['Int']['output'];
};

export type ConversationSummary = {
  __typename?: 'ConversationSummary';
  input_tokens: Scalars['Int']['output'];
  output_tokens: Scalars['Int']['output'];
  span_count: Scalars['Int']['output'];
  total_duration_ns: Scalars['Int']['output'];
  trace_count: Scalars['Int']['output'];
};

export type ConversationTag = {
  __typename?: 'ConversationTag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CreateAutomatedRolloutConfigInput = {
  ending_variation_id?: InputMaybe<Scalars['String']['input']>;
  environments: Array<AgentRolloutEnvironmentInput>;
  flag_key: Scalars['String']['input'];
  pr_number?: InputMaybe<Scalars['Int']['input']>;
  pr_url?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['StringID']['input'];
  project_key?: InputMaybe<Scalars['String']['input']>;
  repo_full_name?: InputMaybe<Scalars['String']['input']>;
  starting_variation_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQueryFilterRuleInput = {
  /**
   * When non-empty, filters attributes instead of excluding/including the entire item.
   * Exclude: remove these attribute keys. Include: keep only these attribute keys.
   */
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  filter_operation: FilterOperationType;
  filter_operation_rate: Scalars['Float']['input'];
  is_rule_enabled: Scalars['Boolean']['input'];
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
  query: Scalars['String']['input'];
  rule_name: Scalars['String']['input'];
};

export type DailyErrorCount = {
  __typename?: 'DailyErrorCount';
  count: Scalars['Int64']['output'];
  date: Scalars['Timestamp']['output'];
  project_id: Scalars['ID']['output'];
};

export type DailySessionCount = {
  __typename?: 'DailySessionCount';
  count: Scalars['Int64']['output'];
  date: Scalars['Timestamp']['output'];
  project_id: Scalars['ID']['output'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  id: Scalars['ID']['output'];
  last_admin_to_edit_id: Scalars['ID']['output'];
  layout: Scalars['String']['output'];
  name: Scalars['String']['output'];
  project_id: Scalars['ID']['output'];
};

export enum DashboardChartType {
  Histogram = 'Histogram',
  Timeline = 'Timeline',
  TimelineBar = 'TimelineBar',
}

/**
 * Top-level dashboard rendering mode. `Standard` is the existing graph-grid
 * dashboard. `Brief` is an Analytical Report rendered from a Brief JSON payload.
 */
export enum DashboardKind {
  Brief = 'Brief',
  Standard = 'Standard',
}

export type DashboardMetricConfig = {
  __typename?: 'DashboardMetricConfig';
  aggregator?: Maybe<MetricAggregator>;
  chart_type?: Maybe<DashboardChartType>;
  description: Scalars['String']['output'];
  help_article?: Maybe<Scalars['String']['output']>;
  max_good_value?: Maybe<Scalars['Float']['output']>;
  max_needs_improvement_value?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  poor_value?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export enum DashboardTemplateType {
  AwsMetrics = 'AWSMetrics',
  FrontendMetrics = 'FrontendMetrics',
  None = 'None',
}

export type DateHistogramBucketSize = {
  calendar_interval: OpenSearchCalendarInterval;
  multiple: Scalars['Int']['input'];
};

export type DateHistogramOptions = {
  bounds: DateRangeInput;
  bucket_size: DateHistogramBucketSize;
  time_zone: Scalars['String']['input'];
};

export type DateRange = {
  __typename?: 'DateRange';
  end_date?: Maybe<Scalars['Timestamp']['output']>;
  start_date?: Maybe<Scalars['Timestamp']['output']>;
};

export type DateRangeInput = {
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type DateRangeRequiredInput = {
  end_date: Scalars['Timestamp']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type DateRangeRequiredOutput = {
  __typename?: 'DateRangeRequiredOutput';
  end_date?: Maybe<Scalars['Timestamp']['output']>;
  start_date?: Maybe<Scalars['Timestamp']['output']>;
};

export type DeleteQueryFilterRuleInput = {
  id: Scalars['StringID']['input'];
  project_id: Scalars['StringID']['input'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
};

export type EditServiceSettingsInput = {
  rootSpanFilter: Scalars['String']['input'];
};

export enum EmailOptOutCategory {
  All = 'All',
  Billing = 'Billing',
  Digests = 'Digests',
  SessionDigests = 'SessionDigests',
}

export enum EnhancementSource {
  Github = 'github',
  Sourcemap = 'sourcemap',
}

export type ErrorDistributionItem = {
  __typename?: 'ErrorDistributionItem';
  date: Scalars['Timestamp']['output'];
  error_group_id: Scalars['Int64ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Int64']['output'];
};

export type ErrorGroup = {
  __typename?: 'ErrorGroup';
  created_at: Scalars['Timestamp']['output'];
  environments?: Maybe<Scalars['String']['output']>;
  error_frequency: Array<Scalars['Int64']['output']>;
  error_metrics: Array<ErrorDistributionItem>;
  event: Array<Maybe<Scalars['String']['output']>>;
  first_occurrence?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['Int64ID']['output'];
  is_public: Scalars['Boolean']['output'];
  jira_issue_links?: Maybe<Array<LinkedJiraIssue>>;
  last_occurrence?: Maybe<Scalars['Timestamp']['output']>;
  mapped_stack_trace?: Maybe<Scalars['String']['output']>;
  metadata_log: Array<Maybe<ErrorMetadata>>;
  project_id: Scalars['Int']['output'];
  secure_id: Scalars['String']['output'];
  serviceName?: Maybe<Scalars['String']['output']>;
  snoozed_until?: Maybe<Scalars['Timestamp']['output']>;
  stack_trace?: Maybe<Scalars['String']['output']>;
  state: ErrorState;
  structured_stack_trace: Array<Maybe<ErrorTrace>>;
  type: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type ErrorGroupFrequenciesParamsInput = {
  date_range: DateRangeRequiredInput;
  resolution_minutes: Scalars['Int']['input'];
};

export type ErrorGroupTagAggregation = {
  __typename?: 'ErrorGroupTagAggregation';
  buckets: Array<ErrorGroupTagAggregationBucket>;
  key: Scalars['String']['output'];
};

export type ErrorGroupTagAggregationBucket = {
  __typename?: 'ErrorGroupTagAggregationBucket';
  doc_count: Scalars['Int64']['output'];
  key: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
};

export type ErrorInstance = {
  __typename?: 'ErrorInstance';
  error_object: ErrorObject;
  next_id?: Maybe<Scalars['ID']['output']>;
  previous_id?: Maybe<Scalars['ID']['output']>;
};

export type ErrorMetadata = {
  __typename?: 'ErrorMetadata';
  browser?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  error_id: Scalars['Int']['output'];
  fingerprint: Scalars['String']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  request_id?: Maybe<Scalars['String']['output']>;
  session_id: Scalars['Int']['output'];
  session_secure_id: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  user_properties?: Maybe<Scalars['String']['output']>;
  visited_url?: Maybe<Scalars['String']['output']>;
};

export type ErrorObject = {
  __typename?: 'ErrorObject';
  attributes?: Maybe<Scalars['Map']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  columnNumber?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['Timestamp']['output'];
  environment?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  error_group_id: Scalars['Int']['output'];
  error_group_secure_id: Scalars['String']['output'];
  event: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['Int64ID']['output'];
  lineNumber?: Maybe<Scalars['Int']['output']>;
  log_cursor?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  project_id: Scalars['Int']['output'];
  request_id?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceVersion?: Maybe<Scalars['String']['output']>;
  session?: Maybe<Session>;
  session_id?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  span_id?: Maybe<Scalars['String']['output']>;
  stack_trace: Scalars['String']['output'];
  stack_trace_threads: Array<ErrorThread>;
  structured_stack_trace: Array<Maybe<ErrorTrace>>;
  timestamp: Scalars['Timestamp']['output'];
  trace_id?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ErrorObjectNode = {
  __typename?: 'ErrorObjectNode';
  createdAt: Scalars['Timestamp']['output'];
  environmentId?: Maybe<Scalars['String']['output']>;
  errorGroupSecureID: Scalars['String']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int64ID']['output'];
  project_id: Scalars['Int']['output'];
  serviceName: Scalars['String']['output'];
  serviceVersion: Scalars['String']['output'];
  session?: Maybe<ErrorObjectNodeSession>;
  timestamp: Scalars['Timestamp']['output'];
};

export type ErrorObjectNodeSession = {
  __typename?: 'ErrorObjectNodeSession';
  email?: Maybe<Scalars['String']['output']>;
  excluded: Scalars['Boolean']['output'];
  fingerprint?: Maybe<Scalars['Int']['output']>;
  secureID: Scalars['String']['output'];
};

export type ErrorObjectResults = {
  __typename?: 'ErrorObjectResults';
  error_objects: Array<ErrorObjectNode>;
  totalCount: Scalars['Int64']['output'];
};

export type ErrorResults = {
  __typename?: 'ErrorResults';
  error_groups: Array<ErrorGroup>;
  totalCount: Scalars['Int64']['output'];
};

export enum ErrorState {
  Ignored = 'IGNORED',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
}

export type ErrorThread = {
  __typename?: 'ErrorThread';
  crashed?: Maybe<Scalars['Boolean']['output']>;
  frames: Array<ErrorTrace>;
  index?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  queue?: Maybe<Scalars['String']['output']>;
};

export type ErrorTrace = {
  __typename?: 'ErrorTrace';
  columnNumber?: Maybe<Scalars['Int']['output']>;
  enhancementSource?: Maybe<EnhancementSource>;
  enhancementVersion?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalLink?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  functionName?: Maybe<Scalars['String']['output']>;
  inApp?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<StackFrameKind>;
  lineContent?: Maybe<Scalars['String']['output']>;
  lineNumber?: Maybe<Scalars['Int']['output']>;
  linesAfter?: Maybe<Scalars['String']['output']>;
  linesBefore?: Maybe<Scalars['String']['output']>;
  module?: Maybe<Scalars['String']['output']>;
  native?: Maybe<NativeFrame>;
  sourceMappingErrorMetadata?: Maybe<SourceMappingError>;
  synthetic?: Maybe<Scalars['Boolean']['output']>;
};

export type ErrorsHistogram = {
  __typename?: 'ErrorsHistogram';
  bucket_times: Array<Scalars['Timestamp']['output']>;
  error_objects: Array<Scalars['Int64']['output']>;
};

export type EventChunk = {
  __typename?: 'EventChunk';
  chunk_index: Scalars['Int']['output'];
  session_id: Scalars['Int']['output'];
  timestamp: Scalars['Int64']['output'];
};

export type ExperimentHypothesisBuilderAssistInput = {
  conversation_id?: InputMaybe<Scalars['StringID']['input']>;
  project_id: Scalars['StringID']['input'];
  prompt: Scalars['String']['input'];
};

export type ExternalAttachment = {
  __typename?: 'ExternalAttachment';
  error_comment_id?: Maybe<Scalars['Int']['output']>;
  external_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integration_type: IntegrationType;
  session_comment_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Field = {
  __typename?: 'Field';
  id: Scalars['Int64']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export enum FilterOperationType {
  Exclude = 'Exclude',
  Include = 'Include',
}

export type FilterOption = {
  __typename?: 'FilterOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FilterRule = {
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['StringID']['output'];
  is_rule_enabled: Scalars['Boolean']['output'];
  product_type: ProductType;
  project_id: Scalars['ID']['output'];
  rule_name: Scalars['String']['output'];
  rule_type: FilterRuleType;
  updated_at: Scalars['Timestamp']['output'];
};

export type FilterRuleDetails = {
  __typename?: 'FilterRuleDetails';
  rule: FilterRule;
};

export enum FilterRuleType {
  QueryFilter = 'QueryFilter',
}

export type FilterRulesInput = {
  error_filter_rules_order?: InputMaybe<Array<Scalars['String']['input']>>;
  log_filter_rules_order?: InputMaybe<Array<Scalars['String']['input']>>;
  metric_filter_rules_order?: InputMaybe<Array<Scalars['String']['input']>>;
  session_filter_rules_order?: InputMaybe<Array<Scalars['String']['input']>>;
  trace_filter_rules_order?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FilterRulesResponse = {
  __typename?: 'FilterRulesResponse';
  rules: Array<FilterRuleDetails>;
  rules_order: Array<Scalars['String']['output']>;
};

export type FilterSettings = {
  __typename?: 'FilterSettings';
  filter_rules?: Maybe<ProjectFilterRules>;
  sampling?: Maybe<Sampling>;
};

export type FlagCleanup = {
  __typename?: 'FlagCleanup';
  cleaned_at: Scalars['Timestamp']['output'];
  flag_name: Scalars['String']['output'];
  pr_link: Scalars['String']['output'];
};

export type FlagCleanupPromptInput = {
  flag_key: Scalars['String']['input'];
  /** Whether teammates can read the resulting conversation. Omitted means shared. */
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  project_id: Scalars['StringID']['input'];
  prompt: Scalars['String']['input'];
  repositories: Array<Scalars['String']['input']>;
};

export type FlagCleanupResults = {
  __typename?: 'FlagCleanupResults';
  flag_cleanups: Array<FlagCleanup>;
  totalCount: Scalars['Int64']['output'];
};

export type FlagEvaluationSession = {
  __typename?: 'FlagEvaluationSession';
  latest_evaluation_timestamp: Scalars['Timestamp']['output'];
  secure_session_id: Scalars['String']['output'];
};

export type FlagVariation = {
  __typename?: 'FlagVariation';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Any']['output']>;
};

export type FlagVariationInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Any']['input']>;
};

export enum FlagVariationType {
  Boolean = 'boolean',
  Json = 'json',
  Number = 'number',
  String = 'string',
}

/**
 * A single cohort row in a v2 funnel result. `groupValues` is parallel to the
 * `breakdown_by` array in the query and is positional — entry i is the value
 * for breakdown_by[i]. For the single-group case (empty breakdown_by) the
 * slice is empty.
 */
export type FunnelGroupResult = {
  __typename?: 'FunnelGroupResult';
  groupValues: Array<Scalars['String']['output']>;
  steps: Array<FunnelStepResult>;
};

export type FunnelResults = {
  __typename?: 'FunnelResults';
  steps: Array<FunnelStepResult>;
};

/**
 * v2 funnel response shape. Always contains at least one `FunnelGroupResult`:
 * either the single ungrouped result (empty breakdown_by) or up to
 * `breakdown_limit` cohort rows ordered DESC by total step count.
 */
export type FunnelResultsV2 = {
  __typename?: 'FunnelResultsV2';
  groups: Array<FunnelGroupResult>;
};

export type FunnelStep = {
  __typename?: 'FunnelStep';
  query: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FunnelStepInput = {
  query: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type FunnelStepResult = {
  __typename?: 'FunnelStepResult';
  count: Scalars['Int']['output'];
  step_index: Scalars['Int']['output'];
};

export type GitHubGitAccess = {
  __typename?: 'GitHubGitAccess';
  policy: GitHubGitPolicy;
  token: Scalars['String']['output'];
};

/**
 * The git-proxy's per-operation policy for one GitHub token (SEC-9536 R1).
 * Repo and ref entries are exact names, or prefixes when they end in "*".
 * Ref deletions are never allowed.
 */
export type GitHubGitPolicy = {
  __typename?: 'GitHubGitPolicy';
  /** Whether reads outside read_repos go upstream with no credential (true) or are refused. */
  anonymous_reads: Scalars['Boolean']['output'];
  /** Empty for a member credential, which names no conversation. */
  conversation_id: Scalars['String']['output'];
  create_refs: Array<Scalars['String']['output']>;
  /** Refs no push may create or update, whatever the rules above allow. */
  deny_refs: Array<Scalars['String']['output']>;
  /** owner/repo entries git-upload-pack reads with the token. */
  read_repos: Array<Scalars['String']['output']>;
  run_kind: Scalars['String']['output'];
  update_refs: Array<Scalars['String']['output']>;
  /** owner/repo entries git-receive-pack may target. */
  write_repos: Array<Scalars['String']['output']>;
};

export type GitHubInstallation = {
  __typename?: 'GitHubInstallation';
  accountLogin: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  installationId: Scalars['String']['output'];
};

export type GitHubRepo = {
  __typename?: 'GitHubRepo';
  is_public: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  repo_id: Scalars['String']['output'];
};

export type GitlabProject = {
  __typename?: 'GitlabProject';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nameWithNameSpace: Scalars['String']['output'];
};

export type Graph = {
  __typename?: 'Graph';
  breakdownBy?: Maybe<Scalars['StringArray']['output']>;
  breakdownLimit?: Maybe<Scalars['Int']['output']>;
  bucketByKey?: Maybe<Scalars['String']['output']>;
  bucketCount?: Maybe<Scalars['Int']['output']>;
  bucketInterval?: Maybe<Scalars['Int']['output']>;
  comparisonMode?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  environments?: Maybe<Scalars['StringArray']['output']>;
  /**
   * Y-axis scaling when exemplars are shown. `clamp` (default when unset) keeps
   * the axis on metric bounds and clamps out-of-range exemplars to the chart edge.
   * `fit` expands the Y-domain so exemplars fall in-plot.
   */
  exemplarScaleMode?: Maybe<Scalars['String']['output']>;
  expressions: Array<MetricExpression>;
  /** Formulas evaluated over `metricSeries` (e.g. `A / B * 100`). */
  formulas?: Maybe<Array<GraphFormula>>;
  funnelSteps?: Maybe<Array<FunnelStep>>;
  groupByKeys?: Maybe<Scalars['StringArray']['output']>;
  heatmapSecureSessionId?: Maybe<Scalars['String']['output']>;
  heatmapSessionTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  limitFunctionType?: Maybe<MetricAggregator>;
  limitMetric?: Maybe<Scalars['String']['output']>;
  /**
   * Lettered input queries for calculated expressions (e.g. series A, B).
   * Absent/empty means a legacy single-query graph using `query` + `expressions`.
   */
  metricSeries?: Maybe<Array<GraphMetricSeries>>;
  nullHandling?: Maybe<Scalars['String']['output']>;
  productType: ProductType;
  query: Scalars['String']['output'];
  services?: Maybe<Scalars['StringArray']['output']>;
  showExemplars?: Maybe<Scalars['Boolean']['output']>;
  sql?: Maybe<Scalars['String']['output']>;
  strictOrder?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GraphFormula = {
  __typename?: 'GraphFormula';
  formula: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type GraphFormulaInput = {
  formula: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type GraphInput = {
  afterGraphId?: InputMaybe<Scalars['ID']['input']>;
  breakdownBy?: InputMaybe<Scalars['StringArray']['input']>;
  breakdownLimit?: InputMaybe<Scalars['Int']['input']>;
  bucketByKey?: InputMaybe<Scalars['String']['input']>;
  bucketCount?: InputMaybe<Scalars['Int']['input']>;
  bucketInterval?: InputMaybe<Scalars['Int']['input']>;
  comparisonMode?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  environments?: InputMaybe<Scalars['StringArray']['input']>;
  /** Y-axis scaling when exemplars are shown. `clamp` (default when unset) or `fit`. */
  exemplarScaleMode?: InputMaybe<Scalars['String']['input']>;
  expressions: Array<MetricExpressionInput>;
  formulas?: InputMaybe<Array<GraphFormulaInput>>;
  funnelSteps?: InputMaybe<Array<FunnelStepInput>>;
  groupByKeys?: InputMaybe<Scalars['StringArray']['input']>;
  heatmapSecureSessionId?: InputMaybe<Scalars['String']['input']>;
  heatmapSessionTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitFunctionType?: InputMaybe<MetricAggregator>;
  limitMetric?: InputMaybe<Scalars['String']['input']>;
  metricSeries?: InputMaybe<Array<GraphMetricSeriesInput>>;
  nullHandling?: InputMaybe<Scalars['String']['input']>;
  productType: ProductType;
  query: Scalars['String']['input'];
  services?: InputMaybe<Scalars['StringArray']['input']>;
  showExemplars?: InputMaybe<Scalars['Boolean']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  strictOrder?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  visualizationId: Scalars['ID']['input'];
};

export type GraphMetricSeries = {
  __typename?: 'GraphMetricSeries';
  expressions: Array<MetricExpression>;
  layout?: Maybe<Scalars['String']['output']>;
  query: Scalars['String']['output'];
  seriesId: Scalars['String']['output'];
};

export type GraphMetricSeriesInput = {
  expressions: Array<MetricExpressionInput>;
  layout?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  seriesId: Scalars['String']['input'];
};

export type HistogramBucket = {
  __typename?: 'HistogramBucket';
  bucket: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  range_end: Scalars['Float']['output'];
  range_start: Scalars['Float']['output'];
};

export type IngestDelay = {
  __typename?: 'IngestDelay';
  p50: Scalars['Float']['output'];
  p90: Scalars['Float']['output'];
  p100: Scalars['Float']['output'];
};

export enum IngestReason {
  Filter = 'Filter',
  Rate = 'Rate',
  Sample = 'Sample',
}

export type IntegrationProjectMapping = {
  __typename?: 'IntegrationProjectMapping';
  external_id: Scalars['String']['output'];
  project_id: Scalars['ID']['output'];
};

export type IntegrationProjectMappingInput = {
  external_id: Scalars['String']['input'];
  project_id: Scalars['ID']['input'];
};

export type IntegrationStatus = {
  __typename?: 'IntegrationStatus';
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  integrated: Scalars['Boolean']['output'];
  resourceType: Scalars['String']['output'];
};

export enum IntegrationType {
  Cloudflare = 'Cloudflare',
  GitHub = 'GitHub',
  GitHubVega = 'GitHubVega',
  GitLab = 'GitLab',
  IncidentIo = 'IncidentIO',
  Jira = 'Jira',
  Slack = 'Slack',
}

export type Invoice = {
  __typename?: 'Invoice';
  amountDue?: Maybe<Scalars['Int64']['output']>;
  amountPaid?: Maybe<Scalars['Int64']['output']>;
  attemptCount?: Maybe<Scalars['Int64']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type IssuesSearchResult = {
  __typename?: 'IssuesSearchResult';
  id: Scalars['String']['output'];
  issue_url: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type JiraIssueCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  issueType: Scalars['String']['input'];
  jiraProjectKey: Scalars['String']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  projectID: Scalars['StringID']['input'];
  sourceLink?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type JiraIssueCreateResult = {
  __typename?: 'JiraIssueCreateResult';
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issueKey: Scalars['String']['output'];
  issueUrl: Scalars['String']['output'];
};

export type JiraIssueType = {
  __typename?: 'JiraIssueType';
  description: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scope?: Maybe<JiraIssueTypeScope>;
  self: Scalars['String']['output'];
  subtask: Scalars['Boolean']['output'];
  untranslatedName: Scalars['String']['output'];
};

export type JiraIssueTypeScope = {
  __typename?: 'JiraIssueTypeScope';
  project?: Maybe<JiraProjectIdentifier>;
  type: Scalars['String']['output'];
};

export type JiraProject = {
  __typename?: 'JiraProject';
  id: Scalars['String']['output'];
  issueTypes?: Maybe<Array<Maybe<JiraIssueType>>>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  self: Scalars['String']['output'];
};

export type JiraProjectIdentifier = {
  __typename?: 'JiraProjectIdentifier';
  id: Scalars['String']['output'];
};

export type JiraTeam = {
  __typename?: 'JiraTeam';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  team_id: Scalars['String']['output'];
};

export enum KeyType {
  Boolean = 'Boolean',
  Creatable = 'Creatable',
  Numeric = 'Numeric',
  String = 'String',
}

export type KeyValueSuggestion = {
  __typename?: 'KeyValueSuggestion';
  key: Scalars['String']['output'];
  values: Array<ValueSuggestion>;
};

export type LdEnvironment = {
  __typename?: 'LDEnvironment';
  critical: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LdFlag = {
  __typename?: 'LDFlag';
  archived: Scalars['Boolean']['output'];
  deprecated: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  temporary: Scalars['Boolean']['output'];
  variations: Array<LdFlagVariation>;
};

export type LdFlagEvaluations = {
  __typename?: 'LDFlagEvaluations';
  metadata: Array<Scalars['Any']['output']>;
  series: Array<Scalars['Any']['output']>;
};

export type LdFlagVariation = {
  __typename?: 'LDFlagVariation';
  description: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Any']['output']>;
};

export type LengthRange = {
  __typename?: 'LengthRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type LengthRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type LinkedJiraIssue = {
  __typename?: 'LinkedJiraIssue';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  issueKey: Scalars['String']['output'];
  issueUrl: Scalars['String']['output'];
};

export type Log = {
  __typename?: 'Log';
  environment?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  level: LogLevel;
  logAttributes: Scalars['Map']['output'];
  message: Scalars['String']['output'];
  projectID: Scalars['Int']['output'];
  secureSessionID?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  serviceVersion?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  spanID?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Timestamp']['output'];
  traceID?: Maybe<Scalars['String']['output']>;
};

export type LogConnection = Connection & {
  __typename?: 'LogConnection';
  edges: Array<LogEdge>;
  pageInfo: PageInfo;
};

export type LogEdge = Edge & {
  __typename?: 'LogEdge';
  cursor: Scalars['String']['output'];
  node: Log;
};

export enum LogLevel {
  Debug = 'debug',
  Error = 'error',
  Fatal = 'fatal',
  Info = 'info',
  Panic = 'panic',
  Trace = 'trace',
  Warn = 'warn',
}

export type LogLine = {
  __typename?: 'LogLine';
  body: Scalars['String']['output'];
  labels: Scalars['String']['output'];
  severity?: Maybe<LogLevel>;
  timestamp: Scalars['Timestamp']['output'];
};

export enum LogSource {
  Backend = 'backend',
  Frontend = 'frontend',
}

export type LogsHistogram = {
  __typename?: 'LogsHistogram';
  buckets: Array<LogsHistogramBucket>;
  objectCount: Scalars['UInt64']['output'];
  sampleFactor: Scalars['Float']['output'];
  totalCount: Scalars['UInt64']['output'];
};

export type LogsHistogramBucket = {
  __typename?: 'LogsHistogramBucket';
  bucketId: Scalars['UInt64']['output'];
  counts: Array<LogsHistogramBucketCount>;
};

export type LogsHistogramBucketCount = {
  __typename?: 'LogsHistogramBucketCount';
  count: Scalars['UInt64']['output'];
  level: LogLevel;
};

export type MatchedErrorObject = {
  __typename?: 'MatchedErrorObject';
  event: Array<Maybe<Scalars['String']['output']>>;
  id: Scalars['Int64ID']['output'];
  score: Scalars['Float']['output'];
  stack_trace: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum MetricAggregator {
  Avg = 'Avg',
  Count = 'Count',
  CountDistinct = 'CountDistinct',
  CountDistinctKey = 'CountDistinctKey',
  Max = 'Max',
  Min = 'Min',
  None = 'None',
  P50 = 'P50',
  P75 = 'P75',
  P90 = 'P90',
  P95 = 'P95',
  P99 = 'P99',
  /**
   * Population-aggregator only (`population_function_type`): the percentage
   * (0-100) of population units that sent at least one `query`-matching event
   * in the evaluation window. Requires an explicit population
   * (`population_query` and/or `population_window`); not valid as a first-pass
   * `function_type` or as a plain metric aggregator.
   */
  PercentUnits = 'PercentUnits',
  Sum = 'Sum',
}

export type MetricBucket = {
  __typename?: 'MetricBucket';
  bucket_id: Scalars['UInt64']['output'];
  bucket_max?: Maybe<Scalars['Float']['output']>;
  bucket_min?: Maybe<Scalars['Float']['output']>;
  bucket_value?: Maybe<Scalars['Float']['output']>;
  column: Scalars['String']['output'];
  group: Array<Scalars['String']['output']>;
  metric_type: MetricAggregator;
  metric_value?: Maybe<Scalars['Float']['output']>;
  yhat_lower?: Maybe<Scalars['Float']['output']>;
  yhat_upper?: Maybe<Scalars['Float']['output']>;
};

export enum MetricBucketBy {
  Histogram = 'Histogram',
  None = 'None',
  Timestamp = 'Timestamp',
}

export type MetricConnection = Connection & {
  __typename?: 'MetricConnection';
  edges: Array<MetricEdge>;
  pageInfo: PageInfo;
};

export type MetricEdge = Edge & {
  __typename?: 'MetricEdge';
  cursor: Scalars['String']['output'];
  node: MetricRow;
};

export type MetricExemplarsResult = {
  __typename?: 'MetricExemplarsResult';
  /**
   * Start of the window actually queried. Exemplars are retained up to the
   * 30d horizon (coarser table TTLs), so this is clamped to now()-30d and may
   * be later than the requested range start.
   */
  exemplar_window_start: Scalars['Timestamp']['output'];
  exemplars: Array<MetricRowExemplar>;
  /**
   * True when the requested range started before the 30d exemplar horizon and
   * was clamped — the UI can surface a "last 30d" hint.
   */
  truncated_to_horizon: Scalars['Boolean']['output'];
};

export type MetricExpression = {
  __typename?: 'MetricExpression';
  aggregator: MetricAggregator;
  column: Scalars['String']['output'];
};

export type MetricExpressionInput = {
  aggregator: MetricAggregator;
  column: Scalars['String']['input'];
  /**
   * Optional population-level (second-pass) aggregator that enables two-level
   * aggregation.
   *
   * When set, the query aggregates in two passes:
   * 1. Per unit: rows are grouped by the query's `group_by` fields (the "unit",
   *    e.g. a context/user key) and reduced with `aggregator`.
   * 2. Across units: those per-unit values are reduced with
   *    `population_aggregator` into a single value per time bucket.
   *
   * Example — `aggregator: Sum`, `population_aggregator: P99`, `group_by: [user]`
   * yields `P99( Sum(value) per user )`: the 99th percentile, taken across users,
   * of each user's summed value.
   *
   * The per-unit groups are collapsed, so the result is a single series per
   * bucket (no group dimension is returned). `group_by` is required for this to
   * take effect; without it the field is ignored and only `aggregator` is
   * applied. When null (the default) the query performs ordinary single-pass
   * aggregation. This mirrors LaunchDarkly metric semantics.
   */
  population_aggregator?: InputMaybe<MetricAggregator>;
};

export type MetricFormulaInput = {
  formula: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type MetricRow = {
  __typename?: 'MetricRow';
  aggregationTemporality: Scalars['Int']['output'];
  attributes: Scalars['Map']['output'];
  exemplars: Array<MetricRowExemplar>;
  flags: Scalars['UInt64']['output'];
  isMonotonic: Scalars['Boolean']['output'];
  metricDescription: Scalars['String']['output'];
  metricName: Scalars['String']['output'];
  metricUnit: Scalars['String']['output'];
  projectID: Scalars['Int']['output'];
  serviceName: Scalars['String']['output'];
  startTimestamp: Scalars['Timestamp']['output'];
  timestamp: Scalars['Timestamp']['output'];
  type: MetricRowType;
  value: Scalars['Float']['output'];
};

export type MetricRowExemplar = {
  __typename?: 'MetricRowExemplar';
  attributes: Scalars['Map']['output'];
  /**
   * Owning metric identity from the metrics row. Present so clients can color
   * or categorize exemplars when a filter covers multiple metric_name values.
   */
  metric_name: Scalars['String']['output'];
  secureSessionID: Scalars['String']['output'];
  spanID: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  traceID: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum MetricRowType {
  Empty = 'empty',
  ExponentialHistogram = 'exponentialHistogram',
  Gauge = 'gauge',
  Histogram = 'histogram',
  Sum = 'sum',
  Summary = 'summary',
}

export type MetricSeriesQueryInput = {
  expressions: Array<MetricExpressionInput>;
  params: QueryInput;
  series_id: Scalars['String']['input'];
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsBuckets = {
  __typename?: 'MetricsBuckets';
  bucket_count: Scalars['UInt64']['output'];
  buckets: Array<MetricBucket>;
  ingest_delay?: Maybe<IngestDelay>;
  metric_unit?: Maybe<Scalars['String']['output']>;
  query_stats?: Maybe<QueryStats>;
  sample_factor: Scalars['Float']['output'];
};

export type MetricsQueryInput = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  include_null_or_empty_groups?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  product_type: ProductType;
  query_id: Scalars['String']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addIntegrationToProject: Scalars['Boolean']['output'];
  addIntegrationToWorkspace: Scalars['Boolean']['output'];
  agentDispatch: AgentDispatchPayload;
  agentFollowupPrompt: AgentFollowupPromptPayload;
  agentPrompt: AgentMessage;
  automatedFlagCleanup: AutomatedFlagCleanupPayload;
  createAlert?: Maybe<Alert>;
  createAutomatedRolloutConfig: Scalars['String']['output'];
  createCloudflareProxy: Scalars['String']['output'];
  createJiraIssueForAlert?: Maybe<JiraIssueCreateResult>;
  createJiraIssueForErrorGroup?: Maybe<JiraIssueCreateResult>;
  createJiraIssueForSession?: Maybe<JiraIssueCreateResult>;
  createProject?: Maybe<Project>;
  createQueryFilterRule: QueryFilterRule;
  createSavedSegment?: Maybe<SavedSegment>;
  deleteAlert: Scalars['Boolean']['output'];
  deleteGraph: Scalars['Boolean']['output'];
  deleteQueryFilterRule: Scalars['Boolean']['output'];
  deleteSavedSegment?: Maybe<Scalars['Boolean']['output']>;
  deleteSessions: Scalars['Boolean']['output'];
  deleteVisualization: Scalars['Boolean']['output'];
  disconnectGitHub: Scalars['Boolean']['output'];
  editProjectSettings?: Maybe<AllProjectSettings>;
  editSavedSegment?: Maybe<Scalars['Boolean']['output']>;
  editServiceGithubSettings?: Maybe<Service>;
  editServiceSettings?: Maybe<ServiceSettings>;
  experiment_hypothesis_builder_assist: AgentMessage;
  exportSession: Scalars['Boolean']['output'];
  flagCleanupPrompt: AgentMessage;
  ld_patch_flag_tags: Scalars['Boolean']['output'];
  markErrorGroupAsViewed?: Maybe<ErrorGroup>;
  markSessionAsViewed?: Maybe<Session>;
  pricingConciergePrompt: AgentMessage;
  recordAgentResult: Scalars['Boolean']['output'];
  removeIntegrationFromProject: Scalars['Boolean']['output'];
  removeIntegrationFromWorkspace: Scalars['Boolean']['output'];
  search_query_suggestion: AgentMessage;
  shareConversation: Scalars['Boolean']['output'];
  signAiTermsRecord: Scalars['Boolean']['output'];
  startIncidentInvestigation: StartIncidentInvestigationPayload;
  stopAgent: Scalars['Boolean']['output'];
  storeAgentMessage: AgentMessage;
  submitRegistrationForm?: Maybe<Scalars['Boolean']['output']>;
  syncSlackIntegration: SlackSyncResponse;
  tagConversation: Scalars['Boolean']['output'];
  testAlertConfiguration: Scalars['Boolean']['output'];
  testErrorEnhancement?: Maybe<ErrorObject>;
  untagConversation: Scalars['Boolean']['output'];
  updateAlert?: Maybe<Alert>;
  updateAlertDisabled: Scalars['Boolean']['output'];
  updateAllowMeterOverage?: Maybe<Workspace>;
  updateErrorGroupIsPublic?: Maybe<ErrorGroup>;
  updateErrorGroupState?: Maybe<ErrorGroup>;
  updateFilterSettings: FilterSettings;
  updateIntegrationProjectMappings: Scalars['Boolean']['output'];
  updateQueryFilterRule: QueryFilterRule;
  updateSessionIsPublic?: Maybe<Session>;
  upsertGraph: Graph;
  upsertSlackChannel: SanitizedSlackChannel;
  upsertVegaProjectConfiguration: VegaProjectConfiguration;
  upsertVegaSlackConfiguration: VegaSlackConfiguration;
  upsertVisualization: Scalars['ID']['output'];
  vega_upsert_artifact?: Maybe<Artifact>;
};

export type MutationAddIntegrationToProjectArgs = {
  code: Scalars['String']['input'];
  integration_type?: InputMaybe<IntegrationType>;
  project_id: Scalars['ID']['input'];
};

export type MutationAddIntegrationToWorkspaceArgs = {
  code: Scalars['String']['input'];
  integration_type?: InputMaybe<IntegrationType>;
  workspace_id: Scalars['ID']['input'];
};

export type MutationAgentDispatchArgs = {
  input: AgentDispatchInput;
};

export type MutationAgentFollowupPromptArgs = {
  input: AgentFollowupPromptInput;
};

export type MutationAgentPromptArgs = {
  input: AgentPromptInput;
};

export type MutationAutomatedFlagCleanupArgs = {
  input: AutomatedFlagCleanupInput;
};

export type MutationCreateAlertArgs = {
  auto_investigation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  destinations: Array<AlertDestinationInput>;
  evaluation_delay_seconds?: InputMaybe<Scalars['Int']['input']>;
  function_column?: InputMaybe<Scalars['String']['input']>;
  function_type: MetricAggregator;
  group_by_key?: InputMaybe<Scalars['String']['input']>;
  group_by_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  hide_graph?: InputMaybe<Scalars['Boolean']['input']>;
  investigation_cooldown?: InputMaybe<Scalars['Int']['input']>;
  investigation_prompt?: InputMaybe<Scalars['String']['input']>;
  investigation_repositories?: InputMaybe<Scalars['StringArray']['input']>;
  message_content?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  no_data_behavior?: InputMaybe<NoDataBehavior>;
  permission_mode?: InputMaybe<Scalars['String']['input']>;
  population_function_type?: InputMaybe<MetricAggregator>;
  population_query?: InputMaybe<Scalars['String']['input']>;
  population_window?: InputMaybe<Scalars['Int']['input']>;
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  send_resolved_alert?: InputMaybe<Scalars['Boolean']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['StringMap']['input']>;
  threshold_condition?: InputMaybe<ThresholdCondition>;
  threshold_cooldown?: InputMaybe<Scalars['Int']['input']>;
  threshold_type?: InputMaybe<ThresholdType>;
  threshold_value?: InputMaybe<Scalars['Float']['input']>;
  threshold_window?: InputMaybe<Scalars['Int']['input']>;
  warn_threshold_value?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationCreateAutomatedRolloutConfigArgs = {
  input: CreateAutomatedRolloutConfigInput;
};

export type MutationCreateCloudflareProxyArgs = {
  proxy_subdomain: Scalars['String']['input'];
  workspace_id: Scalars['ID']['input'];
};

export type MutationCreateJiraIssueForAlertArgs = {
  alertID: Scalars['ID']['input'];
  input: JiraIssueCreateInput;
};

export type MutationCreateJiraIssueForErrorGroupArgs = {
  errorGroupSecureID: Scalars['String']['input'];
  input: JiraIssueCreateInput;
};

export type MutationCreateJiraIssueForSessionArgs = {
  input: JiraIssueCreateInput;
  sessionSecureID: Scalars['String']['input'];
};

export type MutationCreateProjectArgs = {
  name: Scalars['String']['input'];
  workspace_id: Scalars['ID']['input'];
};

export type MutationCreateQueryFilterRuleArgs = {
  input: CreateQueryFilterRuleInput;
};

export type MutationCreateSavedSegmentArgs = {
  advanced_search_params?: InputMaybe<AdvancedSearchParamsInput>;
  entity_type: SavedSegmentEntityType;
  name: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
  query: Scalars['String']['input'];
};

export type MutationDeleteAlertArgs = {
  alert_id: Scalars['ID']['input'];
  project_id: Scalars['StringID']['input'];
};

export type MutationDeleteGraphArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteQueryFilterRuleArgs = {
  input: DeleteQueryFilterRuleInput;
};

export type MutationDeleteSavedSegmentArgs = {
  segment_id: Scalars['ID']['input'];
};

export type MutationDeleteSessionsArgs = {
  params: QueryInput;
  project_id: Scalars['ID']['input'];
  sessionCount: Scalars['Int']['input'];
};

export type MutationDeleteVisualizationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationEditProjectSettingsArgs = {
  autoResolveStaleErrorsDayInterval?: InputMaybe<Scalars['Int']['input']>;
  error_filters?: InputMaybe<Scalars['StringArray']['input']>;
  error_json_paths?: InputMaybe<Scalars['StringArray']['input']>;
  excluded_users?: InputMaybe<Scalars['StringArray']['input']>;
  filterSessionsWithoutError?: InputMaybe<Scalars['Boolean']['input']>;
  filter_chrome_extension?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['StringID']['input'];
  rage_click_count?: InputMaybe<Scalars['Int']['input']>;
  rage_click_radius_pixels?: InputMaybe<Scalars['Int']['input']>;
  rage_click_window_seconds?: InputMaybe<Scalars['Int']['input']>;
  sampling?: InputMaybe<SamplingInput>;
};

export type MutationEditSavedSegmentArgs = {
  advanced_search_params?: InputMaybe<AdvancedSearchParamsInput>;
  entity_type: SavedSegmentEntityType;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
  query: Scalars['String']['input'];
};

export type MutationEditServiceGithubSettingsArgs = {
  build_prefix?: InputMaybe<Scalars['String']['input']>;
  github_prefix?: InputMaybe<Scalars['String']['input']>;
  github_repo_path?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int64ID']['input'];
  project_id: Scalars['ID']['input'];
};

export type MutationEditServiceSettingsArgs = {
  input: EditServiceSettingsInput;
  project_id: Scalars['StringID']['input'];
  service_id: Scalars['Int64ID']['input'];
};

export type MutationExperiment_Hypothesis_Builder_AssistArgs = {
  input: ExperimentHypothesisBuilderAssistInput;
};

export type MutationExportSessionArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type MutationFlagCleanupPromptArgs = {
  input: FlagCleanupPromptInput;
};

export type MutationLd_Patch_Flag_TagsArgs = {
  add_tags?: InputMaybe<Array<Scalars['String']['input']>>;
  flag_key: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
  project_key: Scalars['String']['input'];
  remove_tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationMarkErrorGroupAsViewedArgs = {
  error_secure_id: Scalars['String']['input'];
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationMarkSessionAsViewedArgs = {
  secure_id: Scalars['String']['input'];
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationPricingConciergePromptArgs = {
  input: PricingConciergePromptInput;
};

export type MutationRecordAgentResultArgs = {
  input: RecordAgentResultInput;
};

export type MutationRemoveIntegrationFromProjectArgs = {
  integration_type?: InputMaybe<IntegrationType>;
  project_id: Scalars['ID']['input'];
};

export type MutationRemoveIntegrationFromWorkspaceArgs = {
  integration_type: IntegrationType;
  workspace_id: Scalars['ID']['input'];
};

export type MutationSearch_Query_SuggestionArgs = {
  input: SearchQuerySuggestionInput;
};

export type MutationShareConversationArgs = {
  conversation_id: Scalars['StringID']['input'];
  project_id: Scalars['StringID']['input'];
};

export type MutationSignAiTermsRecordArgs = {
  enabled: Scalars['Boolean']['input'];
};

export type MutationStartIncidentInvestigationArgs = {
  input: StartIncidentInvestigationInput;
};

export type MutationStopAgentArgs = {
  conversation_id: Scalars['StringID']['input'];
};

export type MutationStoreAgentMessageArgs = {
  input: StoreAgentMessageInput;
};

export type MutationSubmitRegistrationFormArgs = {
  heard_about: Scalars['String']['input'];
  pun?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  team_size: Scalars['String']['input'];
  use_case: Scalars['String']['input'];
  workspace_id: Scalars['ID']['input'];
};

export type MutationSyncSlackIntegrationArgs = {
  project_id: Scalars['ID']['input'];
};

export type MutationTagConversationArgs = {
  conversation_id: Scalars['StringID']['input'];
  key: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
  value: Scalars['String']['input'];
};

export type MutationTestAlertConfigurationArgs = {
  alert_configuration: AlertConfigurationInput;
  project_id: Scalars['StringID']['input'];
};

export type MutationTestErrorEnhancementArgs = {
  build_prefix?: InputMaybe<Scalars['String']['input']>;
  error_object_id: Scalars['Int64ID']['input'];
  github_prefix?: InputMaybe<Scalars['String']['input']>;
  github_repo_path: Scalars['String']['input'];
  save_error?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUntagConversationArgs = {
  conversation_id: Scalars['StringID']['input'];
  key: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
};

export type MutationUpdateAlertArgs = {
  alert_id: Scalars['ID']['input'];
  auto_investigation_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  destinations?: InputMaybe<Array<AlertDestinationInput>>;
  evaluation_delay_seconds?: InputMaybe<Scalars['Int']['input']>;
  function_column?: InputMaybe<Scalars['String']['input']>;
  function_type?: InputMaybe<MetricAggregator>;
  group_by_key?: InputMaybe<Scalars['String']['input']>;
  group_by_keys?: InputMaybe<Array<Scalars['String']['input']>>;
  hide_graph?: InputMaybe<Scalars['Boolean']['input']>;
  investigation_cooldown?: InputMaybe<Scalars['Int']['input']>;
  investigation_prompt?: InputMaybe<Scalars['String']['input']>;
  investigation_repositories?: InputMaybe<Scalars['StringArray']['input']>;
  message_content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  no_data_behavior?: InputMaybe<NoDataBehavior>;
  permission_mode?: InputMaybe<Scalars['String']['input']>;
  population_function_type?: InputMaybe<MetricAggregator>;
  population_query?: InputMaybe<Scalars['String']['input']>;
  population_window?: InputMaybe<Scalars['Int']['input']>;
  product_type?: InputMaybe<ProductType>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  send_resolved_alert?: InputMaybe<Scalars['Boolean']['input']>;
  sql?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['StringMap']['input']>;
  threshold_condition?: InputMaybe<ThresholdCondition>;
  threshold_cooldown?: InputMaybe<Scalars['Int']['input']>;
  threshold_type?: InputMaybe<ThresholdType>;
  threshold_value?: InputMaybe<Scalars['Float']['input']>;
  threshold_window?: InputMaybe<Scalars['Int']['input']>;
  warn_threshold_value?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateAlertDisabledArgs = {
  alert_id: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  project_id: Scalars['StringID']['input'];
};

export type MutationUpdateAllowMeterOverageArgs = {
  allow_meter_overage: Scalars['Boolean']['input'];
  workspace_id: Scalars['ID']['input'];
};

export type MutationUpdateErrorGroupIsPublicArgs = {
  error_group_secure_id: Scalars['String']['input'];
  is_public: Scalars['Boolean']['input'];
};

export type MutationUpdateErrorGroupStateArgs = {
  secure_id: Scalars['String']['input'];
  snoozed_until?: InputMaybe<Scalars['Timestamp']['input']>;
  state: ErrorState;
};

export type MutationUpdateFilterSettingsArgs = {
  input: UpdateFilterSettingsInput;
};

export type MutationUpdateIntegrationProjectMappingsArgs = {
  integration_type: IntegrationType;
  project_mappings: Array<IntegrationProjectMappingInput>;
  workspace_id: Scalars['ID']['input'];
};

export type MutationUpdateQueryFilterRuleArgs = {
  input: UpdateQueryFilterRuleInput;
};

export type MutationUpdateSessionIsPublicArgs = {
  is_public: Scalars['Boolean']['input'];
  session_secure_id: Scalars['String']['input'];
};

export type MutationUpsertGraphArgs = {
  graph: GraphInput;
};

export type MutationUpsertSlackChannelArgs = {
  name: Scalars['String']['input'];
  project_id: Scalars['ID']['input'];
};

export type MutationUpsertVegaProjectConfigurationArgs = {
  input: VegaProjectConfigurationInput;
};

export type MutationUpsertVegaSlackConfigurationArgs = {
  input: VegaSlackConfigurationInput;
};

export type MutationUpsertVisualizationArgs = {
  visualization: VisualizationInput;
};

export type MutationVega_Upsert_ArtifactArgs = {
  artifact_type: Scalars['String']['input'];
  conversation_id: Scalars['StringID']['input'];
  event_payload?: InputMaybe<Scalars['Any']['input']>;
  event_type?: InputMaybe<Scalars['String']['input']>;
  external_id: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['Any']['input']>;
  relationship: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NamedCount = {
  __typename?: 'NamedCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NativeFrame = {
  __typename?: 'NativeFrame';
  imageUUID?: Maybe<Scalars['String']['output']>;
  instructionOffset?: Maybe<Scalars['Int']['output']>;
};

export type NetworkHistogramParamsInput = {
  attribute?: InputMaybe<NetworkRequestAttribute>;
  lookback_days: Scalars['Float']['input'];
};

export enum NetworkRequestAttribute {
  BodySize = 'body_size',
  ConnectLatency = 'connect_latency',
  DnsLatency = 'dns_latency',
  GraphqlOperation = 'graphql_operation',
  InitiatorType = 'initiator_type',
  Latency = 'latency',
  Method = 'method',
  RedirectLatency = 'redirect_latency',
  RequestId = 'request_id',
  ResponseSize = 'response_size',
  Status = 'status',
  Url = 'url',
}

export type NewUsersCount = {
  __typename?: 'NewUsersCount';
  count: Scalars['Int64']['output'];
};

export enum NoDataBehavior {
  Alert = 'ALERT',
  Normal = 'NORMAL',
  NoChange = 'NO_CHANGE',
}

export type OAuthClient = {
  __typename?: 'OAuthClient';
  app_name: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
};

export enum OpenSearchCalendarInterval {
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Month = 'month',
  Quarter = 'quarter',
  Week = 'week',
  Year = 'year',
}

export type PaEvent = {
  __typename?: 'PAEvent';
  attributes: Scalars['Map']['output'];
  contextKeys: Scalars['Map']['output'];
  secureSessionID: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  type: Scalars['String']['output'];
};

export type PaEventConnection = Connection & {
  __typename?: 'PAEventConnection';
  edges: Array<PaEventEdge>;
  pageInfo: PageInfo;
  sampled: Scalars['Boolean']['output'];
};

export type PaEventEdge = Edge & {
  __typename?: 'PAEventEdge';
  cursor: Scalars['String']['output'];
  node: PaEvent;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type ParsedQueryFilters = {
  __typename?: 'ParsedQueryFilters';
  attributes: Array<QueryAttributeFilter>;
  body: Array<Scalars['String']['output']>;
};

export type Plan = {
  __typename?: 'Plan';
  aws_mp_subscription?: Maybe<AwsMarketplaceSubscription>;
  enableBillingLimits: Scalars['Boolean']['output'];
  errorsLimit: Scalars['Int64']['output'];
  errorsRate: Scalars['Float']['output'];
  interval: SubscriptionInterval;
  logsLimit: Scalars['Int64']['output'];
  logsRate: Scalars['Float']['output'];
  membersLimit?: Maybe<Scalars['Int64']['output']>;
  metricsLimit: Scalars['Int64']['output'];
  metricsRate: Scalars['Float']['output'];
  sessionsLimit: Scalars['Int64']['output'];
  sessionsRate: Scalars['Float']['output'];
  tracesLimit: Scalars['Int64']['output'];
  tracesRate: Scalars['Float']['output'];
  type: PlanType;
};

export enum PlanType {
  Developer2025 = 'Developer2025',
  Enterprise = 'Enterprise',
  Foundation = 'Foundation',
  FoundationSs = 'FoundationSS',
  Free = 'Free',
  Guardian = 'Guardian',
  GuardianTrial2024 = 'GuardianTrial2024',
}

export type PredictionSettings = {
  changepointPriorScale: Scalars['Float']['input'];
  intervalSeconds: Scalars['Int']['input'];
  intervalWidth: Scalars['Float']['input'];
  thresholdCondition: ThresholdCondition;
};

export type PricingConciergePromptInput = {
  conversation_id?: InputMaybe<Scalars['StringID']['input']>;
  max_turns?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  prompt: Scalars['String']['input'];
};

export enum ProductType {
  Clicks = 'Clicks',
  ContextKeys = 'ContextKeys',
  Errors = 'Errors',
  Events = 'Events',
  LdCustomEvents = 'LDCustomEvents',
  Logs = 'Logs',
  Metrics = 'Metrics',
  PaEvents = 'PAEvents',
  Sessions = 'Sessions',
  Traces = 'Traces',
}

export type Project = {
  __typename?: 'Project';
  billing_email?: Maybe<Scalars['String']['output']>;
  error_filters?: Maybe<Scalars['StringArray']['output']>;
  error_json_paths?: Maybe<Scalars['StringArray']['output']>;
  excluded_users?: Maybe<Scalars['StringArray']['output']>;
  filter_chrome_extension?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  platforms?: Maybe<Scalars['StringArray']['output']>;
  rage_click_count?: Maybe<Scalars['Int']['output']>;
  rage_click_radius_pixels?: Maybe<Scalars['Int']['output']>;
  rage_click_window_seconds?: Maybe<Scalars['Int']['output']>;
  secret?: Maybe<Scalars['String']['output']>;
  verbose_id: Scalars['String']['output'];
  workspace?: Maybe<Workspace>;
  workspace_id: Scalars['ID']['output'];
};

export type ProjectFilterRules = {
  __typename?: 'ProjectFilterRules';
  error_filter_rules_order: Array<Scalars['String']['output']>;
  log_filter_rules_order: Array<Scalars['String']['output']>;
  metric_filter_rules_order: Array<Scalars['String']['output']>;
  session_filter_rules_order: Array<Scalars['String']['output']>;
  trace_filter_rules_order: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  admin?: Maybe<Admin>;
  admin_role?: Maybe<WorkspaceAdminRole>;
  admin_role_by_project?: Maybe<WorkspaceAdminRole>;
  agentArtifact?: Maybe<ArtifactDetail>;
  agentDispatchStatus: AgentDispatchStatusPayload;
  aiChatLimitStatus: AiChatLimitStatus;
  aiConversationHistory: AiConversationHistoryResults;
  ai_query_suggestion: QueryOutput;
  alert: Alert;
  alert_options: Array<FilterOption>;
  alerting_alert_group_states: AlertGroupStateResults;
  alerting_alert_state_changes: AlertStateChangeResults;
  alerts: Array<Maybe<Alert>>;
  automatedRolloutConfig?: Maybe<AutomatedRolloutConfig>;
  averageSessionLength?: Maybe<AverageSessionLength>;
  billingDetails: BillingDetails;
  billingDetailsForProject?: Maybe<BillingDetails>;
  click_sessions: SessionResults;
  clientIntegration: IntegrationStatus;
  conversationArtifacts: Array<Artifact>;
  conversation_history: ConversationHistoryResponse;
  customer_portal_url: Scalars['String']['output'];
  dailyErrorFrequency: Array<Scalars['Int64']['output']>;
  dailyErrorsCount: Array<Maybe<DailyErrorCount>>;
  dailySessionsCount: Array<Maybe<DailySessionCount>>;
  dashboard_options: Array<FilterOption>;
  debug_ld_account_gen_ai_setting_enabled: Scalars['Boolean']['output'];
  email_opt_outs: Array<EmailOptOutCategory>;
  environment_suggestion?: Maybe<Array<Maybe<Field>>>;
  errorGroupTags: Array<ErrorGroupTagAggregation>;
  error_group?: Maybe<ErrorGroup>;
  error_groups: ErrorResults;
  error_groups_for_flag_variation: ErrorResults;
  error_instance?: Maybe<ErrorInstance>;
  error_object?: Maybe<ErrorObject>;
  error_object_for_log?: Maybe<ErrorObject>;
  error_objects: ErrorObjectResults;
  error_resolution_suggestion: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<ErrorObject>>>;
  errors_histogram: ErrorsHistogram;
  errors_keys: Array<QueryKey>;
  errors_metrics: MetricsBuckets;
  event_chunk_url: Scalars['String']['output'];
  event_chunks: Array<EventChunk>;
  event_sessions: SessionResults;
  events?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  events_keys: Array<QueryKey>;
  events_metrics: MetricsBuckets;
  existing_logs_traces: Array<Scalars['String']['output']>;
  experiment_hypothesis_suggestion: Scalars['String']['output'];
  filterRules: FilterRulesResponse;
  flagCleanups: FlagCleanupResults;
  get_concurrent_browser_tab_sessions: Array<ConcurrentBrowserTabSession>;
  get_flag_preview_bundle_upload_url: Scalars['String']['output'];
  get_source_map_upload_urls_ld: Array<Scalars['String']['output']>;
  get_symbol_upload_urls_ld: Array<Scalars['String']['output']>;
  github_access_token: Scalars['String']['output'];
  github_git_access: GitHubGitAccess;
  github_installation_id: Scalars['Int64']['output'];
  github_issue_labels: Array<Scalars['String']['output']>;
  github_repos?: Maybe<Array<GitHubRepo>>;
  gitlab_projects?: Maybe<Array<GitlabProject>>;
  graph: Graph;
  graph_options: Array<FilterOption>;
  graph_templates: Array<Graph>;
  heatmap_clicks?: Maybe<Array<ClickInformation>>;
  identifier_suggestion: Array<Scalars['String']['output']>;
  incident_io_alert: Scalars['String']['output'];
  incident_io_alerts: Scalars['String']['output'];
  incident_io_follow_ups: Scalars['String']['output'];
  incident_io_incident: Scalars['String']['output'];
  incident_io_incident_updates: Scalars['String']['output'];
  incident_io_incidents: Scalars['String']['output'];
  integration_project_mappings: Array<IntegrationProjectMapping>;
  isSessionPending?: Maybe<Scalars['Boolean']['output']>;
  is_integrated_with: Scalars['Boolean']['output'];
  is_project_integrated_with: Scalars['Boolean']['output'];
  is_workspace_integrated_with: Scalars['Boolean']['output'];
  jira_projects?: Maybe<Array<JiraProject>>;
  joinable_workspaces?: Maybe<Array<Maybe<Workspace>>>;
  key_values: Array<Scalars['String']['output']>;
  key_values_suggestions: Array<KeyValueSuggestion>;
  keys: Array<QueryKey>;
  last_alert_group_states: Array<AlertGroupState>;
  last_alert_state_changes: Array<Maybe<AlertStateChange>>;
  last_alerting_alert_group_state?: Maybe<AlertGroupState>;
  last_alerting_state_change?: Maybe<AlertStateChange>;
  ld_environments: Array<LdEnvironment>;
  ld_flag: LdFlag;
  ld_flag_evaluations: LdFlagEvaluations;
  liveUsersCount?: Maybe<Scalars['Int64']['output']>;
  log_lines: Array<LogLine>;
  logs: LogConnection;
  logsIntegration: IntegrationStatus;
  logs_error_objects: Array<ErrorObject>;
  logs_histogram: LogsHistogram;
  logs_keys: Array<QueryKey>;
  logs_metrics: MetricsBuckets;
  /**
   * Per-datapoint exemplars (trace/session references) for a single metric,
   * sampled for overlay on the metric chart. Resolves the metrics table by
   * range age / bucket (1s → 1m → 5m → 1h); the returned range is clamped to
   * the last 30d. Sampling is value-agnostic (time-stratified hash sample).
   */
  metric_exemplars: MetricExemplarsResult;
  metric_tag_values: Array<Scalars['String']['output']>;
  metric_tags: Array<Scalars['String']['output']>;
  metrics: MetricsBuckets;
  metricsIntegration: IntegrationStatus;
  metrics_batched: Array<BatchedMetricsResult>;
  /**
   * Evaluate calculated expressions over multiple independently-filtered metric
   * series. All series share product_type, group_by, and bucket settings; each
   * series has its own filter (`params`) and aggregator.
   */
  metrics_formula: MetricsBuckets;
  network_histogram?: Maybe<CategoryHistogramPayload>;
  newUsersCount?: Maybe<NewUsersCount>;
  oauth_client_metadata?: Maybe<OAuthClient>;
  pa_events: PaEventConnection;
  pa_events_funnel: FunnelResults;
  /**
   * v2 funnel query with optional cohort breakdown. `breakdown_by` is a
   * separate dimension from `group_by` (which still controls the COUNT
   * DISTINCT tuple). Pass `breakdown_by: []` for the single-group case;
   * `breakdown_limit` is the top-N cap on cohort rows (1-100, ordered DESC
   * by total step count).
   */
  pa_events_funnel_v2: FunnelResultsV2;
  project?: Maybe<Project>;
  projectArtifacts: ArtifactResults;
  projectHasViewedASession?: Maybe<Session>;
  projectSettings?: Maybe<AllProjectSettings>;
  projectSuggestion: Array<Maybe<Project>>;
  projects?: Maybe<Array<Maybe<Project>>>;
  queryFilterRule: QueryFilterRuleDetails;
  rageClicksForProject: Array<RageClickEventForProject>;
  rage_clicks: Array<RageClickEvent>;
  referrers: Array<Maybe<ReferrerTablePayload>>;
  resources?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  saved_segments?: Maybe<Array<Maybe<SavedSegment>>>;
  search_issues: Array<IssuesSearchResult>;
  serverIntegration: IntegrationStatus;
  serviceByName?: Maybe<Service>;
  serviceConnections: ServiceConnections;
  serviceMap: Array<ServiceDependency>;
  serviceSettings?: Maybe<ServiceSettings>;
  services?: Maybe<ServiceConnection>;
  session?: Maybe<Session>;
  sessionChunkPreviewFrames: SessionChunkPreviewFrames;
  session_comments: Array<Maybe<SessionComment>>;
  session_exports: Array<SessionExportWithSession>;
  session_insight?: Maybe<SessionInsight>;
  session_intervals: Array<SessionInterval>;
  session_summary: SessionSummaryResponse;
  session_users_report: Array<SessionsReportRow>;
  sessions: SessionResults;
  sessions_for_flag_evaluation: Array<FlagEvaluationSession>;
  sessions_histogram: SessionsHistogram;
  sessions_keys: Array<QueryKey>;
  sessions_metrics: MetricsBuckets;
  slack_channel_suggestion: Array<SanitizedSlackChannel>;
  sourcemap_files: Array<S3File>;
  sourcemap_versions: Array<Scalars['String']['output']>;
  sso_login?: Maybe<SsoLogin>;
  subscription_details?: Maybe<SubscriptionDetails>;
  system_configuration: SystemConfiguration;
  team_query_history: Array<TeamQueryHistoryEntry>;
  timeline_indicator_events: Array<TimelineIndicatorEvent>;
  timestamp_event_chunk_url: Scalars['String']['output'];
  topUsers: Array<Maybe<TopUsersPayload>>;
  trace?: Maybe<TracePayload>;
  traceConversations: ConversationConnection;
  traceServiceSummary: TraceServiceSummaryResult;
  traceSummaries: TraceSummaryConnection;
  trace_conversation?: Maybe<TraceConversationPayload>;
  trace_for_span?: Maybe<TracePayload>;
  traces: TraceConnection;
  tracesIntegration: IntegrationStatus;
  traces_keys: Array<QueryKey>;
  traces_metrics: MetricsBuckets;
  unprocessedSessionsCount?: Maybe<Scalars['Int64']['output']>;
  url_key_values: Array<UrlKeyValue>;
  usageHistory: UsageHistory;
  userFingerprintCount?: Maybe<UserFingerprintCount>;
  value_suggestions: Array<ValueSuggestion>;
  vega_integration_status: VegaIntegrationStatus;
  vega_project_configuration?: Maybe<VegaProjectConfiguration>;
  vega_slack_configuration?: Maybe<VegaSlackConfiguration>;
  visualization: Visualization;
  visualizations: VisualizationsResponse;
  web_vitals: MetricsBuckets;
  websocket_events?: Maybe<Array<Maybe<Scalars['Any']['output']>>>;
  workspace?: Maybe<Workspace>;
  workspacePendingInvites: Array<Maybe<WorkspaceInviteLink>>;
  workspaceSettings?: Maybe<AllWorkspaceSettings>;
  workspace_admins: Array<WorkspaceAdminRole>;
  workspace_admins_by_project_id: Array<WorkspaceAdminRole>;
  workspace_for_invite_link: WorkspaceForInviteLink;
  workspace_for_project?: Maybe<Workspace>;
  workspace_invite_links: WorkspaceInviteLink;
  workspaces?: Maybe<Array<Maybe<Workspace>>>;
  workspaces_count: Scalars['Int64']['output'];
};

export type QueryAdmin_RoleArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryAdmin_Role_By_ProjectArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryAgentArtifactArgs = {
  external_id: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
  type: Scalars['String']['input'];
};

export type QueryAgentDispatchStatusArgs = {
  conversation_id: Scalars['StringID']['input'];
};

export type QueryAiChatLimitStatusArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryAiConversationHistoryArgs = {
  agent_kind?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  date_range?: InputMaybe<DateRangeInput>;
  origin?: InputMaybe<AgentConversationOrigin>;
  page?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  run_kind?: InputMaybe<AgentConversationRunKind>;
  shared_only?: InputMaybe<Scalars['Boolean']['input']>;
  tag_key?: InputMaybe<Scalars['String']['input']>;
  tag_value?: InputMaybe<Scalars['String']['input']>;
  user_email?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAi_Query_SuggestionArgs = {
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
  query: Scalars['String']['input'];
  time_zone: Scalars['String']['input'];
};

export type QueryAlertArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAlert_OptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAlerting_Alert_Group_StatesArgs = {
  alert_id: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  end_date: Scalars['Timestamp']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['Timestamp']['input'];
};

export type QueryAlerting_Alert_State_ChangesArgs = {
  alert_id: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  end_date: Scalars['Timestamp']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['Timestamp']['input'];
};

export type QueryAlertsArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryAutomatedRolloutConfigArgs = {
  id: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
};

export type QueryAverageSessionLengthArgs = {
  lookback_days: Scalars['Float']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryBillingDetailsArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryBillingDetailsForProjectArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryClick_SessionsArgs = {
  count: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sort_desc: Scalars['Boolean']['input'];
  sort_field?: InputMaybe<Scalars['String']['input']>;
};

export type QueryClientIntegrationArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryConversationArtifactsArgs = {
  conversation_id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  relationships?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryConversation_HistoryArgs = {
  after_turn?: InputMaybe<Scalars['Int']['input']>;
  conversation_id: Scalars['StringID']['input'];
};

export type QueryCustomer_Portal_UrlArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryDailyErrorFrequencyArgs = {
  date_offset: Scalars['Int']['input'];
  error_group_secure_id: Scalars['String']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryDailyErrorsCountArgs = {
  date_range: DateRangeInput;
  project_id: Scalars['ID']['input'];
};

export type QueryDailySessionsCountArgs = {
  date_range: DateRangeInput;
  project_id: Scalars['ID']['input'];
};

export type QueryDashboard_OptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDebug_Ld_Account_Gen_Ai_Setting_EnabledArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryEmail_Opt_OutsArgs = {
  admin_id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEnvironment_SuggestionArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryErrorGroupTagsArgs = {
  date_range?: InputMaybe<DateRangeInput>;
  error_group_secure_id: Scalars['String']['input'];
  use_clickhouse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryError_GroupArgs = {
  secure_id: Scalars['String']['input'];
  use_clickhouse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryError_GroupsArgs = {
  count: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryError_Groups_For_Flag_VariationArgs = {
  count: Scalars['Int']['input'];
  flag_key: Scalars['String']['input'];
  flag_variation_value_json: Scalars['String']['input'];
  ld_environment_id: Scalars['String']['input'];
  ld_project_id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
};

export type QueryError_InstanceArgs = {
  error_group_secure_id: Scalars['String']['input'];
  error_object_id?: InputMaybe<Scalars['ID']['input']>;
  params?: InputMaybe<QueryInput>;
};

export type QueryError_ObjectArgs = {
  id: Scalars['Int64ID']['input'];
};

export type QueryError_Object_For_LogArgs = {
  log_cursor: Scalars['String']['input'];
};

export type QueryError_ObjectsArgs = {
  count: Scalars['Int']['input'];
  error_group_secure_id?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id?: InputMaybe<Scalars['String']['input']>;
  query_settings?: InputMaybe<QuerySettingsInput>;
};

export type QueryError_Resolution_SuggestionArgs = {
  error_object_id: Scalars['ID']['input'];
};

export type QueryErrorsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryErrors_HistogramArgs = {
  histogram_options: DateHistogramOptions;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryErrors_KeysArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KeyType>;
};

export type QueryErrors_MetricsArgs = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEvent_Chunk_UrlArgs = {
  index: Scalars['Int']['input'];
  secure_id: Scalars['String']['input'];
};

export type QueryEvent_ChunksArgs = {
  secure_id: Scalars['String']['input'];
};

export type QueryEvent_SessionsArgs = {
  count: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sort_desc: Scalars['Boolean']['input'];
  sort_field?: InputMaybe<Scalars['String']['input']>;
};

export type QueryEventsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryEvents_KeysArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  event?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KeyType>;
};

export type QueryEvents_MetricsArgs = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExisting_Logs_TracesArgs = {
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
  trace_ids: Array<Scalars['String']['input']>;
};

export type QueryExperiment_Hypothesis_SuggestionArgs = {
  project_id: Scalars['StringID']['input'];
  prompt: Scalars['String']['input'];
};

export type QueryFilterRulesArgs = {
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
};

export type QueryFlagCleanupsArgs = {
  count: Scalars['Int']['input'];
  date_range?: InputMaybe<DateRangeInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
};

export type QueryGet_Concurrent_Browser_Tab_SessionsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryGet_Flag_Preview_Bundle_Upload_UrlArgs = {
  api_key: Scalars['String']['input'];
  project_id: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type QueryGet_Source_Map_Upload_Urls_LdArgs = {
  api_key: Scalars['String']['input'];
  paths: Array<Scalars['String']['input']>;
  project_id: Scalars['String']['input'];
};

export type QueryGet_Symbol_Upload_Urls_LdArgs = {
  api_key: Scalars['String']['input'];
  digests?: InputMaybe<Array<Scalars['String']['input']>>;
  paths: Array<Scalars['String']['input']>;
  project_id: Scalars['String']['input'];
  skip_existing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGithub_Installation_IdArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryGithub_Issue_LabelsArgs = {
  repository: Scalars['String']['input'];
  workspace_id: Scalars['ID']['input'];
};

export type QueryGithub_ReposArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryGitlab_ProjectsArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryGraphArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGraph_OptionsArgs = {
  dashboard_id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryHeatmap_ClicksArgs = {
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryIdentifier_SuggestionArgs = {
  project_id: Scalars['StringID']['input'];
  query: Scalars['String']['input'];
};

export type QueryIncident_Io_AlertArgs = {
  alert_id: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
};

export type QueryIncident_Io_AlertsArgs = {
  page_size?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIncident_Io_Follow_UpsArgs = {
  incident_id?: InputMaybe<Scalars['String']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
};

export type QueryIncident_Io_IncidentArgs = {
  incident_id: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
};

export type QueryIncident_Io_Incident_UpdatesArgs = {
  incident_id: Scalars['String']['input'];
  page_size?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
};

export type QueryIncident_Io_IncidentsArgs = {
  page_size?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
};

export type QueryIntegration_Project_MappingsArgs = {
  integration_type?: InputMaybe<IntegrationType>;
  workspace_id: Scalars['ID']['input'];
};

export type QueryIsSessionPendingArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryIs_Integrated_WithArgs = {
  integration_type: IntegrationType;
  project_id: Scalars['StringID']['input'];
};

export type QueryIs_Project_Integrated_WithArgs = {
  integration_type: IntegrationType;
  project_id: Scalars['ID']['input'];
};

export type QueryIs_Workspace_Integrated_WithArgs = {
  integration_type: IntegrationType;
  workspace_id: Scalars['ID']['input'];
};

export type QueryJira_ProjectsArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryKey_ValuesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  event?: InputMaybe<Scalars['String']['input']>;
  key_name: Scalars['String']['input'];
  product_type?: InputMaybe<ProductType>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryKey_Values_SuggestionsArgs = {
  date_range: DateRangeRequiredInput;
  keys: Array<Scalars['String']['input']>;
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
};

export type QueryKeysArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  event?: InputMaybe<Scalars['String']['input']>;
  product_type?: InputMaybe<ProductType>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KeyType>;
};

export type QueryLast_Alert_Group_StatesArgs = {
  alert_id: Scalars['ID']['input'];
};

export type QueryLast_Alert_State_ChangesArgs = {
  alert_id: Scalars['ID']['input'];
};

export type QueryLast_Alerting_Alert_Group_StateArgs = {
  alert_id: Scalars['ID']['input'];
};

export type QueryLast_Alerting_State_ChangeArgs = {
  alert_id: Scalars['ID']['input'];
};

export type QueryLd_EnvironmentsArgs = {
  project_key: Scalars['String']['input'];
};

export type QueryLd_FlagArgs = {
  environment_key?: InputMaybe<Scalars['String']['input']>;
  flag_key: Scalars['String']['input'];
  project_key: Scalars['String']['input'];
};

export type QueryLd_Flag_EvaluationsArgs = {
  environment_key: Scalars['String']['input'];
  flag_key: Scalars['String']['input'];
  from_timestamp?: InputMaybe<Scalars['String']['input']>;
  project_key: Scalars['String']['input'];
  to_timestamp?: InputMaybe<Scalars['String']['input']>;
};

export type QueryLiveUsersCountArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryLog_LinesArgs = {
  params: QueryInput;
  product_type: ProductType;
  project_id: Scalars['ID']['input'];
};

export type QueryLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction: SortDirection;
  limit?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
};

export type QueryLogsIntegrationArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryLogs_Error_ObjectsArgs = {
  log_cursors: Array<Scalars['String']['input']>;
};

export type QueryLogs_HistogramArgs = {
  params: QueryInput;
  project_id: Scalars['ID']['input'];
};

export type QueryLogs_KeysArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KeyType>;
};

export type QueryLogs_MetricsArgs = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMetric_ExemplarsArgs = {
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryMetric_Tag_ValuesArgs = {
  metric_name: Scalars['String']['input'];
  project_id: Scalars['ID']['input'];
  tag_name: Scalars['String']['input'];
};

export type QueryMetric_TagsArgs = {
  metric_name: Scalars['String']['input'];
  project_id: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMetricsArgs = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  include_null_or_empty_groups?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  population_function_type?: InputMaybe<MetricAggregator>;
  population_query?: InputMaybe<Scalars['String']['input']>;
  population_window?: InputMaybe<Scalars['Int']['input']>;
  prediction_settings?: InputMaybe<PredictionSettings>;
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMetricsIntegrationArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryMetrics_BatchedArgs = {
  project_id: Scalars['StringID']['input'];
  queries: Array<MetricsQueryInput>;
};

export type QueryMetrics_FormulaArgs = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  formulas: Array<MetricFormulaInput>;
  group_by: Array<Scalars['String']['input']>;
  include_null_or_empty_groups?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
  series: Array<MetricSeriesQueryInput>;
};

export type QueryNetwork_HistogramArgs = {
  params: NetworkHistogramParamsInput;
  project_id: Scalars['ID']['input'];
};

export type QueryNewUsersCountArgs = {
  lookback_days: Scalars['Float']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryOauth_Client_MetadataArgs = {
  client_id: Scalars['String']['input'];
};

export type QueryPa_EventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction: SortDirection;
  limit?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
};

export type QueryPa_Events_FunnelArgs = {
  funnel_steps: Array<FunnelStepInput>;
  group_by: Array<Scalars['String']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  strict_order?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryPa_Events_Funnel_V2Args = {
  breakdown_by: Array<Scalars['String']['input']>;
  breakdown_limit: Scalars['Int']['input'];
  funnel_steps: Array<FunnelStepInput>;
  group_by: Array<Scalars['String']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  strict_order?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryProjectArgs = {
  id: Scalars['StringID']['input'];
};

export type QueryProjectArtifactsArgs = {
  count: Scalars['Int']['input'];
  creator?: InputMaybe<ArtifactCreatorFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type QueryProjectHasViewedASessionArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryProjectSettingsArgs = {
  projectId: Scalars['StringID']['input'];
};

export type QueryProjectSuggestionArgs = {
  query: Scalars['String']['input'];
};

export type QueryQueryFilterRuleArgs = {
  id: Scalars['StringID']['input'];
  project_id: Scalars['StringID']['input'];
};

export type QueryRageClicksForProjectArgs = {
  lookback_days: Scalars['Float']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryRage_ClicksArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryReferrersArgs = {
  lookback_days: Scalars['Float']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryResourcesArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QuerySaved_SegmentsArgs = {
  entity_type: SavedSegmentEntityType;
  project_id: Scalars['StringID']['input'];
};

export type QuerySearch_IssuesArgs = {
  integration_type: IntegrationType;
  project_id: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};

export type QueryServerIntegrationArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryServiceByNameArgs = {
  name: Scalars['String']['input'];
  project_id: Scalars['StringID']['input'];
};

export type QueryServiceConnectionsArgs = {
  date_range: DateRangeRequiredInput;
  environment_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  project_id: Scalars['StringID']['input'];
  service_name: Scalars['String']['input'];
};

export type QueryServiceMapArgs = {
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryServiceSettingsArgs = {
  project_id: Scalars['StringID']['input'];
  service_id: Scalars['Int64ID']['input'];
};

export type QueryServicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySessionArgs = {
  secure_id: Scalars['String']['input'];
};

export type QuerySessionChunkPreviewFramesArgs = {
  session_secure_id: Scalars['String']['input'];
  timestamp_ms: Scalars['Int']['input'];
};

export type QuerySession_CommentsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QuerySession_ExportsArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QuerySession_InsightArgs = {
  secure_id: Scalars['String']['input'];
};

export type QuerySession_IntervalsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QuerySession_SummaryArgs = {
  project_id: Scalars['StringID']['input'];
  session_id: Scalars['StringID']['input'];
  ts?: InputMaybe<Scalars['Int']['input']>;
  ts_end?: InputMaybe<Scalars['Int']['input']>;
};

export type QuerySession_Users_ReportArgs = {
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySessionsArgs = {
  count: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
  sort_desc: Scalars['Boolean']['input'];
  sort_field?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySessions_For_Flag_EvaluationArgs = {
  date_range: DateRangeRequiredInput;
  flag_key: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  project_id: Scalars['StringID']['input'];
  variation_value?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySessions_HistogramArgs = {
  histogram_options: DateHistogramOptions;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QuerySessions_KeysArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KeyType>;
};

export type QuerySessions_MetricsArgs = {
  bucket_by: Scalars['String']['input'];
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySlack_Channel_SuggestionArgs = {
  project_id: Scalars['ID']['input'];
};

export type QuerySourcemap_FilesArgs = {
  project_id: Scalars['StringID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySourcemap_VersionsArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QuerySso_LoginArgs = {
  domain: Scalars['String']['input'];
};

export type QuerySubscription_DetailsArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryTeam_Query_HistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  project_id: Scalars['StringID']['input'];
  query_type: ProductType;
};

export type QueryTimeline_Indicator_EventsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryTimestamp_Event_Chunk_UrlArgs = {
  secure_id: Scalars['String']['input'];
  timestamp: Scalars['Timestamp']['input'];
};

export type QueryTopUsersArgs = {
  lookback_days: Scalars['Float']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryTraceArgs = {
  project_id: Scalars['StringID']['input'];
  session_secure_id?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['Timestamp']['input'];
  trace_id: Scalars['String']['input'];
};

export type QueryTraceConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryTraceServiceSummaryArgs = {
  params: TraceServiceSummaryParamsInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryTraceSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
};

export type QueryTrace_ConversationArgs = {
  conversation_id: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  project_id: Scalars['StringID']['input'];
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type QueryTrace_For_SpanArgs = {
  project_id: Scalars['StringID']['input'];
  session_secure_id?: InputMaybe<Scalars['String']['input']>;
  span_id: Scalars['String']['input'];
  timestamp: Scalars['Timestamp']['input'];
  trace_id: Scalars['String']['input'];
};

export type QueryTracesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  at?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction: SortDirection;
  limit?: InputMaybe<Scalars['Int']['input']>;
  omitBody?: InputMaybe<Scalars['Boolean']['input']>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  query_settings?: InputMaybe<QuerySettingsInput>;
};

export type QueryTracesIntegrationArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryTraces_KeysArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KeyType>;
};

export type QueryTraces_MetricsArgs = {
  bucket_by?: InputMaybe<Scalars['String']['input']>;
  bucket_count?: InputMaybe<Scalars['Int']['input']>;
  bucket_window?: InputMaybe<Scalars['Int']['input']>;
  column?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<MetricExpressionInput>>;
  group_by: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limit_aggregator?: InputMaybe<MetricAggregator>;
  limit_column?: InputMaybe<Scalars['String']['input']>;
  metric_types?: InputMaybe<Array<MetricAggregator>>;
  params: QueryInput;
  project_id: Scalars['StringID']['input'];
  sql?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUnprocessedSessionsCountArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryUrl_Key_ValuesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUsageHistoryArgs = {
  date_range?: InputMaybe<DateRangeRequiredInput>;
  product_type: ProductType;
  workspace_id: Scalars['ID']['input'];
};

export type QueryUserFingerprintCountArgs = {
  lookback_days: Scalars['Float']['input'];
  project_id: Scalars['ID']['input'];
};

export type QueryValue_SuggestionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  date_range: DateRangeRequiredInput;
  event?: InputMaybe<Scalars['String']['input']>;
  key_name: Scalars['String']['input'];
  product_type?: InputMaybe<ProductType>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryVega_Integration_StatusArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryVega_Project_ConfigurationArgs = {
  project_id: Scalars['StringID']['input'];
};

export type QueryVisualizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVisualizationsArgs = {
  count: Scalars['Int']['input'];
  input: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  project_id: Scalars['StringID']['input'];
};

export type QueryWeb_VitalsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryWebsocket_EventsArgs = {
  session_secure_id: Scalars['String']['input'];
};

export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};

export type QueryWorkspacePendingInvitesArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryWorkspaceSettingsArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryWorkspace_AdminsArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryWorkspace_Admins_By_Project_IdArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryWorkspace_For_Invite_LinkArgs = {
  secret: Scalars['String']['input'];
};

export type QueryWorkspace_For_ProjectArgs = {
  project_id: Scalars['ID']['input'];
};

export type QueryWorkspace_Invite_LinksArgs = {
  workspace_id: Scalars['ID']['input'];
};

export type QueryAttributeFilter = {
  __typename?: 'QueryAttributeFilter';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type QueryFilterRule = FilterRule & {
  __typename?: 'QueryFilterRule';
  /**
   * When non-empty, filters attributes instead of excluding/including the entire item.
   * Exclude: remove these attribute keys. Include: keep only these attribute keys.
   */
  attributes: Array<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  filter_operation: FilterOperationType;
  filter_operation_rate: Scalars['Float']['output'];
  id: Scalars['StringID']['output'];
  is_rule_enabled: Scalars['Boolean']['output'];
  product_type: ProductType;
  project_id: Scalars['ID']['output'];
  query: Scalars['String']['output'];
  rule_name: Scalars['String']['output'];
  rule_type: FilterRuleType;
  updated_at: Scalars['Timestamp']['output'];
};

export type QueryFilterRuleDetails = {
  __typename?: 'QueryFilterRuleDetails';
  rule: QueryFilterRule;
};

export type QueryInput = {
  date_range: DateRangeRequiredInput;
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<SortInput>;
};

export type QueryKey = {
  __typename?: 'QueryKey';
  count: Scalars['UInt64']['output'];
  name: Scalars['String']['output'];
  type: KeyType;
};

export type QueryOutput = {
  __typename?: 'QueryOutput';
  date_range: DateRangeRequiredOutput;
  query: Scalars['String']['output'];
};

export type QuerySettingsInput = {
  disable_sampling?: InputMaybe<Scalars['Boolean']['input']>;
  include_ingest_delay?: InputMaybe<Scalars['Boolean']['input']>;
  include_preview?: InputMaybe<Scalars['Boolean']['input']>;
  return_query_stats?: InputMaybe<Scalars['Boolean']['input']>;
  trace_columns?: InputMaybe<Array<TraceColumn>>;
};

export type QueryStats = {
  __typename?: 'QueryStats';
  rows_matched: Scalars['UInt64']['output'];
  rows_scanned: Scalars['UInt64']['output'];
  was_sampled: Scalars['Boolean']['output'];
};

export type RageClickEvent = {
  __typename?: 'RageClickEvent';
  end_timestamp: Scalars['Timestamp']['output'];
  id: Scalars['Int64ID']['output'];
  project_id: Scalars['ID']['output'];
  session_secure_id: Scalars['String']['output'];
  start_timestamp: Scalars['Timestamp']['output'];
  total_clicks: Scalars['Int']['output'];
};

export type RageClickEventForProject = {
  __typename?: 'RageClickEventForProject';
  identifier: Scalars['String']['output'];
  session_secure_id: Scalars['String']['output'];
  total_clicks: Scalars['Int']['output'];
  user_properties: Scalars['String']['output'];
};

export type RecordAgentResultInput = {
  conversation_id: Scalars['StringID']['input'];
  project_id: Scalars['StringID']['input'];
  result: Scalars['String']['input'];
};

export type ReferrerTablePayload = {
  __typename?: 'ReferrerTablePayload';
  count: Scalars['Int']['output'];
  host: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
};

export enum ReservedClickKey {
  BrowserLanguage = 'browser_language',
  BrowserName = 'browser_name',
  BrowserVersion = 'browser_version',
  City = 'city',
  Classname = 'classname',
  Country = 'country',
  Environment = 'environment',
  Excluded = 'excluded',
  FirstSession = 'first_session',
  Id = 'id',
  Identified = 'identified',
  Identifier = 'identifier',
  Ip = 'ip',
  OsName = 'os_name',
  OsVersion = 'os_version',
  Processed = 'processed',
  RelativeX = 'relative_x',
  RelativeY = 'relative_y',
  SecureSessionId = 'secure_session_id',
  ServiceVersion = 'service_version',
  SessionActiveLength = 'session_active_length',
  SessionLength = 'session_length',
  SessionPagesVisited = 'session_pages_visited',
  State = 'state',
  Tag = 'tag',
  Text = 'text',
  Timestamp = 'timestamp',
  Type = 'type',
  Url = 'url',
  UserAgent = 'user_agent',
  ViewportHeight = 'viewport_height',
  ViewportWidth = 'viewport_width',
  X = 'x',
  Xpath = 'xpath',
  Y = 'y',
}

export enum ReservedErrorGroupKey {
  Event = 'event',
  SecureId = 'secure_id',
  SnoozedUntil = 'snoozed_until',
  Status = 'status',
  Tag = 'tag',
  Type = 'type',
}

export enum ReservedErrorObjectKey {
  Browser = 'browser',
  ClientId = 'client_id',
  Environment = 'environment',
  EnvironmentId = 'environment_id',
  HasSession = 'has_session',
  OsName = 'os_name',
  SecureSessionId = 'secure_session_id',
  ServiceName = 'service_name',
  ServiceVersion = 'service_version',
  Timestamp = 'timestamp',
  TraceId = 'trace_id',
  VisitedUrl = 'visited_url',
}

export enum ReservedErrorsJoinedKey {
  Browser = 'browser',
  ClientId = 'client_id',
  Environment = 'environment',
  EnvironmentId = 'environment_id',
  ErrorInstanceId = 'error_instance_id',
  /** ReservedErrorGroupKey */
  Event = 'event',
  HasSession = 'has_session',
  /** ReservedErrorObjectKey */
  Id = 'id',
  OsName = 'os_name',
  SecureId = 'secure_id',
  SecureSessionId = 'secure_session_id',
  ServiceName = 'service_name',
  ServiceVersion = 'service_version',
  SnoozedUntil = 'snoozed_until',
  Status = 'status',
  Tag = 'tag',
  Timestamp = 'timestamp',
  TraceId = 'trace_id',
  Type = 'type',
  VisitedUrl = 'visited_url',
}

export enum ReservedEventKey {
  BrowserName = 'browser_name',
  BrowserVersion = 'browser_version',
  City = 'city',
  Country = 'country',
  Environment = 'environment',
  Event = 'event',
  FirstSession = 'first_session',
  Identified = 'identified',
  Identifier = 'identifier',
  Ip = 'ip',
  OsName = 'os_name',
  OsVersion = 'os_version',
  SecureSessionId = 'secure_session_id',
  ServiceVersion = 'service_version',
  SessionActiveLength = 'session_active_length',
  SessionLength = 'session_length',
  SessionPagesVisited = 'session_pages_visited',
  State = 'state',
  Timestamp = 'timestamp',
}

export enum ReservedLogKey {
  /** Keep this in alpha order */
  Environment = 'environment',
  EnvironmentId = 'environment_id',
  Level = 'level',
  Message = 'message',
  SecureSessionId = 'secure_session_id',
  ServiceName = 'service_name',
  ServiceVersion = 'service_version',
  Source = 'source',
  SpanId = 'span_id',
  Timestamp = 'timestamp',
  TraceId = 'trace_id',
}

export enum ReservedMetricKey {
  Attributes = 'attributes',
  Count = 'count',
  Environment = 'environment',
  Max = 'max',
  MetricDescription = 'metric_description',
  MetricName = 'metric_name',
  MetricType = 'metric_type',
  MetricUnit = 'metric_unit',
  Min = 'min',
  RetentionDays = 'retention_days',
  SecureSessionId = 'secure_session_id',
  ServiceName = 'service_name',
  ServiceVersion = 'service_version',
  SpanId = 'span_id',
  StartTimestamp = 'start_timestamp',
  Sum = 'sum',
  Timestamp = 'timestamp',
  TraceId = 'trace_id',
  Type = 'type',
  Value = 'value',
}

export enum ReservedSessionKey {
  ActiveLength = 'active_length',
  BrowserName = 'browser_name',
  BrowserVersion = 'browser_version',
  City = 'city',
  Completed = 'completed',
  Country = 'country',
  Environment = 'environment',
  EnvironmentId = 'environment_id',
  Excluded = 'excluded',
  FirstTime = 'first_time',
  HasComments = 'has_comments',
  HasErrors = 'has_errors',
  HasRageClicks = 'has_rage_clicks',
  Identified = 'identified',
  Identifier = 'identifier',
  Ip = 'ip',
  Length = 'length',
  LocState = 'loc_state',
  Normalness = 'normalness',
  OsName = 'os_name',
  OsVersion = 'os_version',
  PagesVisited = 'pages_visited',
  Processed = 'processed',
  Sample = 'sample',
  SecureId = 'secure_id',
  ServiceVersion = 'service_version',
  State = 'state',
  Timestamp = 'timestamp',
  UpdatedAt = 'updated_at',
  Viewed = 'viewed',
  ViewedByAnyone = 'viewed_by_anyone',
  ViewedByMe = 'viewed_by_me',
  WithinBillingQuota = 'within_billing_quota',
}

export enum ReservedTraceKey {
  Duration = 'duration',
  Environment = 'environment',
  EnvironmentId = 'environment_id',
  HasErrors = 'has_errors',
  HighlightType = 'highlight_type',
  Level = 'level',
  Message = 'message',
  MetricName = 'metric_name',
  MetricValue = 'metric_value',
  ParentSpanId = 'parent_span_id',
  SecureSessionId = 'secure_session_id',
  ServiceName = 'service_name',
  ServiceVersion = 'service_version',
  SpanId = 'span_id',
  SpanKind = 'span_kind',
  SpanName = 'span_name',
  Timestamp = 'timestamp',
  TraceId = 'trace_id',
  TraceState = 'trace_state',
}

export enum RetentionPeriod {
  SevenDays = 'SevenDays',
  SixMonths = 'SixMonths',
  ThirtyDays = 'ThirtyDays',
  ThreeMonths = 'ThreeMonths',
  ThreeYears = 'ThreeYears',
  TwelveMonths = 'TwelveMonths',
  TwoYears = 'TwoYears',
}

export type S3File = {
  __typename?: 'S3File';
  key?: Maybe<Scalars['String']['output']>;
};

export type SsoLogin = {
  __typename?: 'SSOLogin';
  client_id: Scalars['String']['output'];
  domain: Scalars['String']['output'];
};

export type Sampling = {
  __typename?: 'Sampling';
  error_exclusion_query?: Maybe<Scalars['String']['output']>;
  error_minute_rate_limit?: Maybe<Scalars['Int64']['output']>;
  error_sampling_rate: Scalars['Float']['output'];
  log_exclusion_query?: Maybe<Scalars['String']['output']>;
  log_minute_rate_limit?: Maybe<Scalars['Int64']['output']>;
  log_sampling_rate: Scalars['Float']['output'];
  /** @deprecated Use filter rules (createQueryFilterRule with product_type=Metrics, filter_operation=Exclude, filter_operation_rate=1) instead. */
  metric_exclusion_query?: Maybe<Scalars['String']['output']>;
  metric_minute_rate_limit?: Maybe<Scalars['Int64']['output']>;
  metric_sampling_rate: Scalars['Float']['output'];
  session_exclusion_query?: Maybe<Scalars['String']['output']>;
  session_minute_rate_limit?: Maybe<Scalars['Int64']['output']>;
  session_sampling_rate: Scalars['Float']['output'];
  trace_exclusion_query?: Maybe<Scalars['String']['output']>;
  trace_minute_rate_limit?: Maybe<Scalars['Int64']['output']>;
  trace_sampling_rate: Scalars['Float']['output'];
};

export type SamplingInput = {
  error_exclusion_query?: InputMaybe<Scalars['String']['input']>;
  error_minute_rate_limit?: InputMaybe<Scalars['Int64']['input']>;
  error_sampling_rate?: InputMaybe<Scalars['Float']['input']>;
  log_exclusion_query?: InputMaybe<Scalars['String']['input']>;
  log_minute_rate_limit?: InputMaybe<Scalars['Int64']['input']>;
  log_sampling_rate?: InputMaybe<Scalars['Float']['input']>;
  metric_exclusion_query?: InputMaybe<Scalars['String']['input']>;
  metric_minute_rate_limit?: InputMaybe<Scalars['Int64']['input']>;
  metric_sampling_rate?: InputMaybe<Scalars['Float']['input']>;
  session_exclusion_query?: InputMaybe<Scalars['String']['input']>;
  session_minute_rate_limit?: InputMaybe<Scalars['Int64']['input']>;
  session_sampling_rate?: InputMaybe<Scalars['Float']['input']>;
  trace_exclusion_query?: InputMaybe<Scalars['String']['input']>;
  trace_minute_rate_limit?: InputMaybe<Scalars['Int64']['input']>;
  trace_sampling_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type SanitizedAdmin = {
  __typename?: 'SanitizedAdmin';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photo_url?: Maybe<Scalars['String']['output']>;
};

export type SanitizedAdminInput = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SanitizedSlackChannel = {
  __typename?: 'SanitizedSlackChannel';
  webhook_channel?: Maybe<Scalars['String']['output']>;
  webhook_channel_id?: Maybe<Scalars['String']['output']>;
};

export type SanitizedSlackChannelInput = {
  webhook_channel_id?: InputMaybe<Scalars['String']['input']>;
  webhook_channel_name?: InputMaybe<Scalars['String']['input']>;
};

export type SavedSegment = {
  __typename?: 'SavedSegment';
  entity_type: SavedSegmentEntityType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  params: SearchParams;
  project_id: Scalars['ID']['output'];
};

export enum SavedSegmentEntityType {
  Error = 'Error',
  Log = 'Log',
  Session = 'Session',
  Trace = 'Trace',
}

export type SearchParams = {
  __typename?: 'SearchParams';
  bucket_by_key?: Maybe<Scalars['String']['output']>;
  bucket_count?: Maybe<Scalars['Int']['output']>;
  bucket_interval?: Maybe<Scalars['Int']['output']>;
  expressions?: Maybe<Array<MetricExpression>>;
  graph_type?: Maybe<Scalars['String']['output']>;
  group_by_keys?: Maybe<Scalars['StringArray']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  limit_function_type?: Maybe<MetricAggregator>;
  limit_metric?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
};

export type SearchQuerySuggestionInput = {
  conversation_id?: InputMaybe<Scalars['StringID']['input']>;
  product_type: ProductType;
  project_id: Scalars['StringID']['input'];
  prompt: Scalars['String']['input'];
};

export type Service = {
  __typename?: 'Service';
  buildPrefix?: Maybe<Scalars['String']['output']>;
  errorDetails?: Maybe<Array<Scalars['String']['output']>>;
  githubPrefix?: Maybe<Scalars['String']['output']>;
  githubRepoPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int64ID']['output'];
  name: Scalars['String']['output'];
  projectID: Scalars['ID']['output'];
  status: ServiceStatus;
};

export type ServiceConnection = Connection & {
  __typename?: 'ServiceConnection';
  edges: Array<Maybe<ServiceEdge>>;
  pageInfo: PageInfo;
};

export type ServiceConnections = {
  __typename?: 'ServiceConnections';
  incoming: Array<Scalars['String']['output']>;
  outgoing: Array<Scalars['String']['output']>;
};

export type ServiceDependency = {
  __typename?: 'ServiceDependency';
  source: Scalars['String']['output'];
  target?: Maybe<Scalars['String']['output']>;
};

export type ServiceEdge = Edge & {
  __typename?: 'ServiceEdge';
  cursor: Scalars['String']['output'];
  node: ServiceNode;
};

export type ServiceNode = {
  __typename?: 'ServiceNode';
  buildPrefix?: Maybe<Scalars['String']['output']>;
  errorDetails?: Maybe<Array<Scalars['String']['output']>>;
  githubPrefix?: Maybe<Scalars['String']['output']>;
  githubRepoPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int64ID']['output'];
  name: Scalars['String']['output'];
  projectID: Scalars['ID']['output'];
  status: ServiceStatus;
};

export type ServiceSettings = {
  __typename?: 'ServiceSettings';
  projectID: Scalars['ID']['output'];
  rootSpanFilter?: Maybe<Scalars['String']['output']>;
  serviceID: Scalars['Int64ID']['output'];
};

export enum ServiceStatus {
  Created = 'created',
  Error = 'error',
  Healthy = 'healthy',
}

export type Session = {
  __typename?: 'Session';
  active_length?: Maybe<Scalars['Int']['output']>;
  app_version?: Maybe<Scalars['String']['output']>;
  browser_name: Scalars['String']['output'];
  browser_version: Scalars['String']['output'];
  chunked?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  client_config?: Maybe<Scalars['String']['output']>;
  client_id: Scalars['String']['output'];
  client_version?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  deviceMemory?: Maybe<Scalars['Int']['output']>;
  direct_download_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enable_recording_network_contents?: Maybe<Scalars['Boolean']['output']>;
  enable_strict_privacy?: Maybe<Scalars['Boolean']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  environment_id?: Maybe<Scalars['String']['output']>;
  event_counts?: Maybe<Scalars['String']['output']>;
  excluded: Scalars['Boolean']['output'];
  excluded_reason?: Maybe<SessionExcludedReason>;
  field_group?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<Field>>>;
  fingerprint?: Maybe<Scalars['Int']['output']>;
  first_time?: Maybe<Scalars['Boolean']['output']>;
  firstload_version?: Maybe<Scalars['String']['output']>;
  has_errors?: Maybe<Scalars['Boolean']['output']>;
  has_rage_clicks?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int64ID']['output'];
  identified: Scalars['Boolean']['output'];
  identifier: Scalars['String']['output'];
  ip: Scalars['String']['output'];
  is_public: Scalars['Boolean']['output'];
  jira_issue_links?: Maybe<Array<LinkedJiraIssue>>;
  language: Scalars['String']['output'];
  last_user_interaction_time: Scalars['Timestamp']['output'];
  ld_project_slug?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  object_storage_enabled?: Maybe<Scalars['Boolean']['output']>;
  os_name: Scalars['String']['output'];
  os_version: Scalars['String']['output'];
  payload_size?: Maybe<Scalars['Int64']['output']>;
  payload_updated_at?: Maybe<Scalars['Timestamp']['output']>;
  postal: Scalars['String']['output'];
  privacy_setting?: Maybe<Scalars['String']['output']>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  project_id: Scalars['Int']['output'];
  resources_url?: Maybe<Scalars['String']['output']>;
  secure_id: Scalars['String']['output'];
  service_name?: Maybe<Scalars['String']['output']>;
  session_feedback?: Maybe<Array<SessionComment>>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  state: Scalars['String']['output'];
  timeline_indicators_url?: Maybe<Scalars['String']['output']>;
  user_object?: Maybe<Scalars['Any']['output']>;
  user_properties?: Maybe<Scalars['String']['output']>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
  web_socket_events_url?: Maybe<Scalars['String']['output']>;
  within_billing_quota?: Maybe<Scalars['Boolean']['output']>;
};

export type SessionChunkPreviewFrames = {
  __typename?: 'SessionChunkPreviewFrames';
  chunk_index: Scalars['Int']['output'];
  chunk_start_ms: Scalars['Int']['output'];
  frame_interval_ms: Scalars['Int']['output'];
  frames: Array<ChunkPreviewFrame>;
  is_complete: Scalars['Boolean']['output'];
};

export type SessionComment = {
  __typename?: 'SessionComment';
  attachments: Array<Maybe<ExternalAttachment>>;
  author?: Maybe<SanitizedAdmin>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Any']['output']>;
  project_id: Scalars['ID']['output'];
  session_id: Scalars['Int']['output'];
  session_secure_id: Scalars['String']['output'];
  tags: Array<Maybe<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Int']['output']>;
  type: SessionCommentType;
  updated_at: Scalars['Timestamp']['output'];
  x_coordinate?: Maybe<Scalars['Float']['output']>;
  y_coordinate?: Maybe<Scalars['Float']['output']>;
};

export enum SessionCommentType {
  Admin = 'Admin',
  Feedback = 'FEEDBACK',
}

export enum SessionExcludedReason {
  BillingQuotaExceeded = 'BillingQuotaExceeded',
  ExclusionFilter = 'ExclusionFilter',
  IgnoredUser = 'IgnoredUser',
  Initializing = 'Initializing',
  NoActivity = 'NoActivity',
  NoError = 'NoError',
  NoTimelineIndicatorEvents = 'NoTimelineIndicatorEvents',
  NoUserEvents = 'NoUserEvents',
  NoUserInteractionEvents = 'NoUserInteractionEvents',
  RateLimitMinute = 'RateLimitMinute',
  RetentionPeriodExceeded = 'RetentionPeriodExceeded',
  Sampled = 'Sampled',
}

export type SessionExportWithSession = {
  __typename?: 'SessionExportWithSession';
  active_length?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['Timestamp']['output'];
  error: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  secure_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SessionInsight = {
  __typename?: 'SessionInsight';
  id: Scalars['ID']['output'];
  insight: Scalars['String']['output'];
  session_id: Scalars['Int']['output'];
};

export type SessionInterval = {
  __typename?: 'SessionInterval';
  active: Scalars['Boolean']['output'];
  duration: Scalars['Int']['output'];
  end_time: Scalars['Timestamp']['output'];
  session_secure_id: Scalars['String']['output'];
  start_time: Scalars['Timestamp']['output'];
};

export enum SessionLifecycle {
  All = 'All',
  Completed = 'Completed',
  Live = 'Live',
}

export type SessionPayload = {
  __typename?: 'SessionPayload';
  errors: Array<Maybe<ErrorObject>>;
  events: Array<Maybe<Scalars['Any']['output']>>;
  last_user_interaction_time: Scalars['Timestamp']['output'];
  rage_clicks: Array<RageClickEvent>;
  session_comments: Array<Maybe<SessionComment>>;
};

export type SessionQuery = {
  __typename?: 'SessionQuery';
  id: Scalars['Int64ID']['output'];
  project_id: Scalars['ID']['output'];
};

export type SessionResults = {
  __typename?: 'SessionResults';
  sessions: Array<Session>;
  totalActiveLength: Scalars['Int64']['output'];
  totalCount: Scalars['Int64']['output'];
  totalLength: Scalars['Int64']['output'];
};

export type SessionSummary = {
  __typename?: 'SessionSummary';
  evaluation: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  summary: Array<Scalars['String']['output']>;
};

export type SessionSummaryResponse = {
  __typename?: 'SessionSummaryResponse';
  evaluation: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
};

export type SessionsHistogram = {
  __typename?: 'SessionsHistogram';
  active_lengths: Array<Scalars['Int64']['output']>;
  bucket_times: Array<Scalars['Timestamp']['output']>;
  inactive_lengths: Array<Scalars['Int64']['output']>;
  sessions_with_errors: Array<Scalars['Int64']['output']>;
  sessions_without_errors: Array<Scalars['Int64']['output']>;
  total_sessions: Array<Scalars['Int64']['output']>;
};

export type SessionsReportDay = {
  __typename?: 'SessionsReportDay';
  day: Scalars['Timestamp']['output'];
  num_sessions: Scalars['UInt64']['output'];
};

export type SessionsReportRow = {
  __typename?: 'SessionsReportRow';
  avg_active_length_mins: Scalars['Float']['output'];
  avg_length_mins: Scalars['Float']['output'];
  daily_sessions: Array<SessionsReportDay>;
  email: Scalars['String']['output'];
  first_session: Scalars['Timestamp']['output'];
  key: Scalars['String']['output'];
  last_session: Scalars['Timestamp']['output'];
  location: Scalars['String']['output'];
  max_active_length_mins: Scalars['Float']['output'];
  max_length_mins: Scalars['Float']['output'];
  num_days_visited: Scalars['UInt64']['output'];
  num_months_visited: Scalars['UInt64']['output'];
  num_sessions: Scalars['UInt64']['output'];
  total_active_length_mins: Scalars['Float']['output'];
  total_length_mins: Scalars['Float']['output'];
};

export type SlackSyncResponse = {
  __typename?: 'SlackSyncResponse';
  newChannelsAddedCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortInput = {
  column: Scalars['String']['input'];
  direction: SortDirection;
};

export type SortOutput = {
  __typename?: 'SortOutput';
  column: Scalars['String']['output'];
  direction: SortDirection;
};

export type SourceMappingError = {
  __typename?: 'SourceMappingError';
  actualMinifiedFetchedPath?: Maybe<Scalars['String']['output']>;
  actualSourcemapFetchedPath?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<SourceMappingErrorCode>;
  mappedColumnNumber?: Maybe<Scalars['Int']['output']>;
  mappedLineNumber?: Maybe<Scalars['Int']['output']>;
  minifiedColumnNumber?: Maybe<Scalars['Int']['output']>;
  minifiedFetchStrategy?: Maybe<Scalars['String']['output']>;
  minifiedFileSize?: Maybe<Scalars['Int']['output']>;
  minifiedLineNumber?: Maybe<Scalars['Int']['output']>;
  sourceMapURL?: Maybe<Scalars['String']['output']>;
  sourcemapFetchStrategy?: Maybe<Scalars['String']['output']>;
  sourcemapFileSize?: Maybe<Scalars['Int']['output']>;
  stackTraceFileURL?: Maybe<Scalars['String']['output']>;
};

export enum SourceMappingErrorCode {
  ErrorConstructingSourceMapUrl = 'Error_Constructing_Source_Map_URL',
  ErrorParsingStackTraceFileUrl = 'Error_Parsing_Stack_Trace_File_Url',
  FileNameMissingFromSourcePath = 'File_Name_Missing_From_Source_Path',
  InvalidSourceMapUrl = 'Invalid_SourceMapURL',
  MinifiedFileLarger = 'Minified_File_Larger',
  MinifiedFileMissingInS3AndUrl = 'Minified_File_Missing_In_S3_And_URL',
  MissingSourceMapFileInS3 = 'Missing_Source_Map_File_In_S3',
  SourceMapFileLarger = 'Source_Map_File_Larger',
  SourcemapFileMissingInS3AndUrl = 'Sourcemap_File_Missing_In_S3_And_URL',
  SourcemapLibraryCouldntParse = 'Sourcemap_Library_Couldnt_Parse',
  SourcemapLibraryCouldntRetrieveSource = 'Sourcemap_Library_Couldnt_Retrieve_Source',
}

export enum StackFrameKind {
  Dart = 'dart',
  Js = 'js',
  Jvm = 'jvm',
  Native = 'native',
  Unknown = 'unknown',
}

export type StartIncidentInvestigationInput = {
  impactedServices?: InputMaybe<Array<Scalars['String']['input']>>;
  incidentId: Scalars['String']['input'];
  incidentSeverity?: InputMaybe<Scalars['String']['input']>;
  incidentSummary?: InputMaybe<Scalars['String']['input']>;
  incidentTitle: Scalars['String']['input'];
  incidentUrl?: InputMaybe<Scalars['String']['input']>;
  ldProjectUrl: Scalars['String']['input'];
  slackChannelId: Scalars['String']['input'];
  slackTeamId: Scalars['String']['input'];
};

export type StartIncidentInvestigationPayload = {
  __typename?: 'StartIncidentInvestigationPayload';
  alreadyExists: Scalars['Boolean']['output'];
  conversationId: Scalars['String']['output'];
  correlationId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StoreAgentMessageInput = {
  content: Scalars['String']['input'];
  conversation_id: Scalars['StringID']['input'];
  error_class?: InputMaybe<Scalars['String']['input']>;
  guardrail_blocked?: InputMaybe<Scalars['Boolean']['input']>;
  is_final: Scalars['Boolean']['input'];
  project_id: Scalars['StringID']['input'];
  role: Scalars['String']['input'];
  tokens_used?: InputMaybe<Scalars['Int']['input']>;
  turn: Scalars['Int']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  session_payload_appended?: Maybe<SessionPayload>;
};

export type SubscriptionSession_Payload_AppendedArgs = {
  initial_events_count: Scalars['Int']['input'];
  session_secure_id: Scalars['String']['input'];
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  baseAmount: Scalars['Int64']['output'];
  billingIngestBlocked: Scalars['Boolean']['output'];
  billingIssue: Scalars['Boolean']['output'];
  discount?: Maybe<SubscriptionDiscount>;
  lastInvoice?: Maybe<Invoice>;
};

export type SubscriptionDiscount = {
  __typename?: 'SubscriptionDiscount';
  amount: Scalars['Int64']['output'];
  name: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  until?: Maybe<Scalars['Timestamp']['output']>;
};

export enum SubscriptionInterval {
  Annual = 'Annual',
  Monthly = 'Monthly',
}

export enum SuggestionType {
  Key = 'Key',
  None = 'None',
  Value = 'Value',
}

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  maintenance_end?: Maybe<Scalars['Timestamp']['output']>;
  maintenance_start?: Maybe<Scalars['Timestamp']['output']>;
};

export type TeamQueryHistoryEntry = {
  __typename?: 'TeamQueryHistoryEntry';
  admin: SanitizedAdmin;
  chartPreview: Array<ChartPreviewBucket>;
  dateRangeEnd: Scalars['Timestamp']['output'];
  dateRangeStart: Scalars['Timestamp']['output'];
  executedAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  parsedFilters: ParsedQueryFilters;
  queryText: Scalars['String']['output'];
  queryType: ProductType;
  resultCount?: Maybe<Scalars['Int64']['output']>;
};

export enum ThresholdCondition {
  Above = 'Above',
  AboveOrEqual = 'AboveOrEqual',
  Below = 'Below',
  BelowOrEqual = 'BelowOrEqual',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  Outside = 'Outside',
}

export enum ThresholdType {
  Anomaly = 'Anomaly',
  Constant = 'Constant',
}

export type TimelineIndicatorEvent = {
  __typename?: 'TimelineIndicatorEvent';
  data?: Maybe<Scalars['Any']['output']>;
  session_secure_id: Scalars['String']['output'];
  sid: Scalars['Float']['output'];
  timestamp: Scalars['Float']['output'];
  type: Scalars['Int']['output'];
};

export type TopUsersPayload = {
  __typename?: 'TopUsersPayload';
  active_time_percentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  total_active_time: Scalars['Int']['output'];
  user_properties: Scalars['String']['output'];
};

export type Trace = {
  __typename?: 'Trace';
  duration: Scalars['Int']['output'];
  environment: Scalars['String']['output'];
  environmentId?: Maybe<Scalars['String']['output']>;
  environmentKey?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<Maybe<TraceEvent>>>;
  hasErrors: Scalars['Boolean']['output'];
  links?: Maybe<Array<Maybe<TraceLink>>>;
  parentSpanID: Scalars['String']['output'];
  projectID: Scalars['Int']['output'];
  secureSessionID: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  serviceVersion: Scalars['String']['output'];
  spanID: Scalars['String']['output'];
  spanKind: Scalars['String']['output'];
  spanName: Scalars['String']['output'];
  startTime: Scalars['Int']['output'];
  statusCode: Scalars['String']['output'];
  statusMessage: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  traceAttributes: Scalars['Map']['output'];
  traceID: Scalars['String']['output'];
  traceState: Scalars['String']['output'];
};

export enum TraceColumn {
  Duration = 'duration',
  HasErrors = 'has_errors',
  HttpAttributes = 'http_attributes',
  HttpStatusCode = 'http_status_code',
  HttpUrl = 'http_url',
  SpanId = 'span_id',
  SpanName = 'span_name',
  TraceId = 'trace_id',
}

export type TraceConnection = Connection & {
  __typename?: 'TraceConnection';
  edges: Array<TraceEdge>;
  pageInfo: PageInfo;
  sampled: Scalars['Boolean']['output'];
};

export type TraceConversationPayload = {
  __typename?: 'TraceConversationPayload';
  conversation_id: Scalars['String']['output'];
  errors: Array<TraceError>;
  spans: Array<Trace>;
  summary: ConversationSummary;
};

export type TraceEdge = Edge & {
  __typename?: 'TraceEdge';
  cursor: Scalars['String']['output'];
  node: Trace;
};

export type TraceError = {
  __typename?: 'TraceError';
  created_at: Scalars['Timestamp']['output'];
  error_group_secure_id: Scalars['String']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  log_cursor?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  span_id?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['Timestamp']['output'];
  trace_id?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type TraceEvent = {
  __typename?: 'TraceEvent';
  attributes: Scalars['Map']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

export type TraceLink = {
  __typename?: 'TraceLink';
  attributes: Scalars['Map']['output'];
  spanID: Scalars['String']['output'];
  traceID: Scalars['String']['output'];
  traceState: Scalars['String']['output'];
};

export type TracePayload = {
  __typename?: 'TracePayload';
  errors: Array<TraceError>;
  trace: Array<Trace>;
};

export type TraceServiceSummaryBucket = {
  __typename?: 'TraceServiceSummaryBucket';
  error_count: Scalars['Int64']['output'];
  request_count: Scalars['Int64']['output'];
  service_name: Scalars['String']['output'];
  time_bucket: Scalars['Timestamp']['output'];
};

export type TraceServiceSummaryParamsInput = {
  date_range: DateRangeRequiredInput;
};

export type TraceServiceSummaryResult = {
  __typename?: 'TraceServiceSummaryResult';
  buckets: Array<TraceServiceSummaryBucket>;
};

export type TraceSummary = {
  __typename?: 'TraceSummary';
  error_count: Scalars['UInt64']['output'];
  in_progress: Scalars['Boolean']['output'];
  projectID: Scalars['Int']['output'];
  root_name: Scalars['String']['output'];
  root_service: Scalars['String']['output'];
  services_touched: Array<Scalars['String']['output']>;
  span_count: Scalars['UInt64']['output'];
  timestamp: Scalars['Timestamp']['output'];
  traceID: Scalars['String']['output'];
  trace_duration: Scalars['Int64']['output'];
};

export type TraceSummaryConnection = Connection & {
  __typename?: 'TraceSummaryConnection';
  edges: Array<TraceSummaryEdge>;
  pageInfo: PageInfo;
  sampled: Scalars['Boolean']['output'];
};

export type TraceSummaryEdge = Edge & {
  __typename?: 'TraceSummaryEdge';
  cursor: Scalars['String']['output'];
  node: TraceSummary;
};

export type UrlKeyValue = {
  __typename?: 'URLKeyValue';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UpdateFilterSettingsInput = {
  filter_rules?: InputMaybe<FilterRulesInput>;
  project_id: Scalars['StringID']['input'];
  sampling?: InputMaybe<SamplingInput>;
};

export type UpdateQueryFilterRuleInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  filter_operation?: InputMaybe<FilterOperationType>;
  filter_operation_rate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['StringID']['input'];
  is_rule_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  project_id: Scalars['StringID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  rule_name?: InputMaybe<Scalars['String']['input']>;
};

export type UsageHistory = {
  __typename?: 'UsageHistory';
  usage: MetricsBuckets;
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
};

export type UserFingerprintCount = {
  __typename?: 'UserFingerprintCount';
  count: Scalars['Int64']['output'];
};

export type UserProperty = {
  __typename?: 'UserProperty';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserPropertyInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ValueSuggestion = {
  __typename?: 'ValueSuggestion';
  count: Scalars['UInt64']['output'];
  rank: Scalars['UInt64']['output'];
  value: Scalars['String']['output'];
};

export type Variable = {
  __typename?: 'Variable';
  defaultValues: Array<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  suggestionType: SuggestionType;
};

export type VariableInput = {
  defaultValues: Array<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  suggestionType: SuggestionType;
};

export type VegaIntegrationStatus = {
  __typename?: 'VegaIntegrationStatus';
  authLink: Scalars['String']['output'];
  installationId: Scalars['String']['output'];
  installations: Array<GitHubInstallation>;
  repositories: Array<GitHubRepo>;
  userTokenValid: Scalars['Boolean']['output'];
};

export type VegaProjectConfiguration = {
  __typename?: 'VegaProjectConfiguration';
  id: Scalars['ID']['output'];
  project_id: Scalars['Int']['output'];
  pull_request_bot_identity_workflows: Array<VegaPullRequestBotIdentityWorkflow>;
  pull_request_title_prefix: Scalars['String']['output'];
};

export type VegaProjectConfigurationInput = {
  project_id: Scalars['StringID']['input'];
  pull_request_bot_identity_workflows?: InputMaybe<Array<VegaPullRequestBotIdentityWorkflow>>;
  pull_request_title_prefix: Scalars['String']['input'];
};

export enum VegaPullRequestBotIdentityWorkflow {
  AutomatedAlertRemediations = 'AUTOMATED_ALERT_REMEDIATIONS',
  AutomatedFlagCleanups = 'AUTOMATED_FLAG_CLEANUPS',
  VegaConversations = 'VEGA_CONVERSATIONS',
}

export type VegaSlackConfiguration = {
  __typename?: 'VegaSlackConfiguration';
  admin_id: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  investigation_project_id?: Maybe<Scalars['String']['output']>;
  investigation_prompt?: Maybe<Scalars['String']['output']>;
  investigation_repositories?: Maybe<Scalars['StringArray']['output']>;
  permission_mode?: Maybe<Scalars['String']['output']>;
};

export type VegaSlackConfigurationInput = {
  investigation_project_id?: InputMaybe<Scalars['String']['input']>;
  investigation_prompt?: InputMaybe<Scalars['String']['input']>;
  investigation_repositories?: InputMaybe<Scalars['StringArray']['input']>;
  permission_mode?: InputMaybe<Scalars['String']['input']>;
};

export type Visualization = {
  __typename?: 'Visualization';
  /**
   * Raw JSON payload for `Brief`-kind dashboards. Stored as a JSON string so
   * the wire schema stays stable; the client validates against the Brief Zod
   * schema before rendering. `null` for `Standard` dashboards.
   */
  briefContent?: Maybe<Scalars['String']['output']>;
  graphs: Array<Graph>;
  id: Scalars['ID']['output'];
  /**
   * Discriminator for dashboard rendering. `Standard` is a grid of graphs
   * (default). `Brief` is an "Analytical Report" rendered from `briefContent`
   * via the @gonfalon/brief renderer.
   */
  kind: DashboardKind;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  timePreset?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
  updatedByAdmin?: Maybe<SanitizedAdmin>;
  variables: Array<Variable>;
};

export type VisualizationInput = {
  briefContent?: InputMaybe<Scalars['String']['input']>;
  dashboardTemplateType?: InputMaybe<DashboardTemplateType>;
  graphIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<DashboardKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['StringID']['input'];
  timePreset?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<VariableInput>>;
};

export type VisualizationsResponse = {
  __typename?: 'VisualizationsResponse';
  count: Scalars['Int']['output'];
  results: Array<Visualization>;
};

export type WebSocketEvent = {
  __typename?: 'WebSocketEvent';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  socketId: Scalars['String']['output'];
  timeStamp: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Workspace = {
  __typename?: 'Workspace';
  allow_meter_overage: Scalars['Boolean']['output'];
  allowed_auto_join_email_origins?: Maybe<Scalars['String']['output']>;
  billing_period_end?: Maybe<Scalars['Timestamp']['output']>;
  cloudflare_proxy?: Maybe<Scalars['String']['output']>;
  errors_max_cents?: Maybe<Scalars['Int']['output']>;
  errors_retention_period: RetentionPeriod;
  id: Scalars['ID']['output'];
  logs_max_cents?: Maybe<Scalars['Int']['output']>;
  logs_retention_period: RetentionPeriod;
  metrics_max_cents?: Maybe<Scalars['Int']['output']>;
  metrics_retention_period: RetentionPeriod;
  name: Scalars['String']['output'];
  next_invoice_date?: Maybe<Scalars['Timestamp']['output']>;
  plan_tier: Scalars['String']['output'];
  projects: Array<Maybe<Project>>;
  retention_period: RetentionPeriod;
  sessions_max_cents?: Maybe<Scalars['Int']['output']>;
  slack_channels?: Maybe<Scalars['String']['output']>;
  slack_webhook_channel?: Maybe<Scalars['String']['output']>;
  traces_max_cents?: Maybe<Scalars['Int']['output']>;
  traces_retention_period: RetentionPeriod;
  unlimited_members: Scalars['Boolean']['output'];
};

export type WorkspaceAdminRole = {
  __typename?: 'WorkspaceAdminRole';
  admin: Admin;
  projectIds: Array<Scalars['ID']['output']>;
  role: Scalars['String']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type WorkspaceForInviteLink = {
  __typename?: 'WorkspaceForInviteLink';
  existing_account: Scalars['Boolean']['output'];
  expiration_date?: Maybe<Scalars['Timestamp']['output']>;
  invitee_email?: Maybe<Scalars['String']['output']>;
  project_id: Scalars['ID']['output'];
  secret: Scalars['String']['output'];
  workspace_id: Scalars['ID']['output'];
  workspace_name: Scalars['String']['output'];
};

export type WorkspaceInviteLink = {
  __typename?: 'WorkspaceInviteLink';
  created_at: Scalars['Timestamp']['output'];
  expiration_date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  invitee_email?: Maybe<Scalars['String']['output']>;
  invitee_role: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};
